var FontFaceObserver = require('fontfaceobserver');

var homeSlideResearch = {
  dance: function () {
    jQuery('.research .counter-tile_number').find('span').remove();
        jQuery('.research .counter-tile_number').each(function () {

          if(!jQuery(this).hasClass('counted')) {
            jQuery(this).prop('Counter',0).animate({
                Counter: jQuery(this).text().replace(/,/g, "")
            }, {
                duration: 3000,
                easing: 'swing',
                step: function (now) {
                  var Text;
                  jQuery(this).addClass('counted');
                  if (jQuery(this).hasClass('hours')) {
                    Text = '<span><</span>' +Math.ceil(now).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<span>hrs</span>';
                  } else {
                    Text = Math.ceil(now).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  }
                    jQuery(this).html(Text);

                }
            });
          }
        });
        setTimeout( function () {
          if(!jQuery('.research .counter-tile_number.plus').hasClass('counted')) {
            jQuery('.research .counter-tile_number.plus').append('<span style="margin-right: -45px;">+</span>');
          }
        }, 3300);
    jQuery('.research .counter-tile_number').addClass('counted');
  }
};

var current_width = jQuery(window).width();

var integrationPartnersTiles = {
  technologyPartnerItems: jQuery('.technology-partner-item'),
  init: function () {

    integrationPartnersTiles.setFilterOptions();
    integrationPartnersTiles.initInteraction();
    integrationPartnersTiles.filterPartnerInit();
    integrationPartnersTiles.initGrid();
    if (jQuery('#technology-partners-search').length > 0) {
      integrationPartnersTiles.initSearch(jQuery('#technology-partners-search'));
    }
    if (jQuery('#research-partners-search').length > 0) {
      integrationPartnersTiles.initSearch(jQuery('#research-partners-search'));
    }
  },
  initGrid: function () {
    var _this = jQuery(this), itemPerRow = 4, itemsCountStart = 0, productFilterValue = jQuery('#technology-partners-integration-filter').val();

      jQuery('.technology-partner-item-container:eq(0)').html('');
      jQuery('.technology-partner-item').removeClass('active');
      jQuery('.technology-partner-item__info').slideUp();
      jQuery('.technology-partner-item').remove();

      integrationPartnersTiles.technologyPartnerItems.each( function () {

        var _this = jQuery(this);

        jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
        itemsCountStart++;

      });

      integrationPartnersTiles.initInteraction();
  },
  initSearch: function (searchField) {


    jQuery(searchField).on('input', function() {
        var _this = jQuery(this), _val = _this.val(), itemsCountStart = 0;

        if (_val.length === 0) {
          jQuery('.technology-partner-item-container:eq(0)').html('');
        }
      if (_val.length >= 3) {
        jQuery('.technology-partner-item-container:eq(0)').html('');
        jQuery('#technology-partners-filter').val('all');
        jQuery('#technology-partners-integration-filter').val('all');

        jQuery('.technology-partner-item').removeClass('active');
        jQuery('.technology-partner-item__info').slideUp();
        jQuery('.technology-partner-item').remove();

        integrationPartnersTiles.technologyPartnerItems.each( function () {

          var _this = jQuery(this), _title = _this.find('.technology-partner-item__mobile-info h3').text().toLowerCase(), _desc = _this.find('.technology-partner-item__mobile-info').text().toLowerCase();

            if (_title.indexOf(_val.toLowerCase()) === 0) {
              jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
              itemsCountStart++;
            }
            if (_desc.length > 0 && _desc.indexOf(_val.toLowerCase()) > -1) {

              jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
              itemsCountStart++;
            }

        });

        if (itemsCountStart === 0) {
          jQuery('.technology-partner-item-container:eq(0)').html('<div style="text-align: center; width: 100%;">No results</div>');
        }

      }

      if (_val.length === 0) {
        jQuery('#technology-partners-filter').val('all');
        jQuery('#technology-partners-integration-filter').val('all');

        jQuery('.technology-partner-item').removeClass('active');
        jQuery('.technology-partner-item__info').slideUp();
        jQuery('.technology-partner-item').remove();

        integrationPartnersTiles.technologyPartnerItems.each( function () {
          var _this = jQuery(this);
          jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
          itemsCountStart++;

        });

      }

      integrationPartnersTiles.initInteraction();

    });

  },
  initInteraction: function () {
    $('.technology-partner-item').magnificPopup({
            type:'inline',
            midClick: true,
            callbacks: {
              close: function() {
                if ($('.technology-partner-level-item__modal-content').length > 0) {
                  $('.technology-partner-level-item__modal-content').show();
                  $('.technology-partner-level-item__integration-details').hide();
                }
              }
            }
        });
  },
  setFilterOptions: function () {
    var technologyPartnerFilterOptions = jQuery('#edit-field-tech-partner-category-tid > option').clone(),
        technologyParnerProductOptions = jQuery('#edit-field-tenable-products-tid > option').clone();

    // -- Append the option item from select#edit-field-tech-partner-category-tid to select#technology-partners-filter
    jQuery('#technology-partners-filter').append(technologyPartnerFilterOptions).ready( function() { jQuery('#edit-field-tech-partner-category-tid-wrapper').remove(); } );

    jQuery('#technology-partners-integration-filter').append(technologyParnerProductOptions).ready( function() { jQuery('#edit-field-tenable-products-tid-wrapper').remove(); } );

    // -- Change text of first option to 'all'
    jQuery('#technology-partners-filter option:eq(0)').val('all');
    jQuery('#technology-partners-integration-filter option:eq(0)').val('all');

  },
  filterPartnerInit: function () {

    jQuery('#technology-partners-filter').on('change', function() {
      var _this = jQuery(this), filterValue = _this.val(), itemPerRow = 4, itemsCountStart = 0, productFilterValue = jQuery('#technology-partners-integration-filter').val();

      jQuery('.technology-partner-item-container:eq(0)').html('');
      jQuery('.technology-partner-item').removeClass('active');
      jQuery('.technology-partner-item__info').slideUp();
      jQuery('.technology-partner-item').remove();

      integrationPartnersTiles.technologyPartnerItems.each( function () {

        var _this = jQuery(this);

        if (productFilterValue !== 'all') {
          if (filterValue === 'all') {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
            jQuery('#technology-partners-integration-filter').val('all');
          } else if (_this.hasClass(filterValue) && _this.hasClass(productFilterValue)) {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
          }
        } else {
          if (filterValue === 'all') {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
          } else if (_this.hasClass(filterValue)) {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
          }
        }

      });

      integrationPartnersTiles.initInteraction();

      if (itemsCountStart === 0) {
        jQuery('.technology-partner-item-container:eq(0)').html('<div style="text-align: center; width: 100%;">No results</div>');
      }

    });

    jQuery('#technology-partners-integration-filter').on('change', function() {
      var _this = jQuery(this), filterValue = _this.val(), itemPerRow = 4, itemsCountStart = 0,  techFilterValue = jQuery('#technology-partners-filter').val();

      jQuery('.technology-partner-item-container:eq(0)').html('');

      jQuery('.technology-partner-item').removeClass('active');
      jQuery('.technology-partner-item__info').slideUp();
      jQuery('.technology-partner-item').remove();

      integrationPartnersTiles.technologyPartnerItems.each( function () {

        var _this = jQuery(this);

        if (techFilterValue !== 'all') {
          if (filterValue === 'all') {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
            jQuery('#technology-partners-filter').val('all');
          } else if (_this.hasClass(filterValue) && _this.hasClass(techFilterValue)) {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
          }
        } else {
          if (filterValue === 'all') {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
          } else if (_this.hasClass(filterValue)) {
            jQuery('.technology-partner-item-container:eq('+integrationPartnersTiles.getCurrentItemRow(itemsCountStart)+')').append(_this);
            itemsCountStart++;
          }
        }

      });

      integrationPartnersTiles.initInteraction();

      if (itemsCountStart === 0) {
        jQuery('.technology-partner-item-container:eq(0)').html('<div style="text-align: center; width: 100%;">No results</div>');
      }

    });
  },
  getCurrentItemRow: function (itemsCountStart) {
    var itemPerRow = 4;

    return Math.floor(itemsCountStart / itemPerRow);
  }
};

(function($){

  var researchTabs = {
    init: function () {

      researchTabs.initializeHTML();

      researchTabs.initializeUI();
    },
    initializeUI: function() {
      const Tabs = $('.tenable-research__tabs');

      Tabs.find('.tenable-research__tabs-nav ul li a').click( function (e) {
        e.preventDefault();
        var _this = $(this), _index = _this.parent().index();

        if (!_this.parent().hasClass('active')) {
          _this.parent().parent().find('li.active').removeClass('active');
          _this.parent().addClass('active');
          _this.parent().parent().parent().parent().find('.tenable-research__content .tenable-research__content-item.active').removeClass('active');
          _this.parent().parent().parent().parent().find('.tenable-research__content .tenable-research__content-item:eq('+_index+')').addClass('active');
        }
      });
    },
    initializeHTML: function() {
      $('.tenable-research__tabs li').each( function () {
          var _this = $(this),
              _index = _this.index(),
              _content = _this.parent().parent().parent().find('.tenable-research__content .tenable-research__content-item:eq('+_index+')').clone();

          _this.append(_content);
          _this.find('.tenable-research__content-item').removeClass('col-sm-3 active');

          if (_this.hasClass('active')) {
            _this.find('.tenable-research__content-item').addClass('active');
          }
      })
    }
  }
  researchTabs.init();





  $('.tenable-training-pyramid li a, .tenable-training-pyramid-content-mobile').click( function (e) {
    e.preventDefault();
    var _this = $(this), tabContent = _this.data('content');
    $('.tenable-training-pyramid-content-tab, .tenable-training-pyramid li a, .tenable-training-pyramid-content-mobile').removeClass('active');
    $('.tenable-training-pyramid-content-tab.'+tabContent+', .tenable-training-pyramid li a.'+tabContent+', .tenable-training-pyramid-content-mobile.'+tabContent).addClass('active');
  });

  $('.show-integration-details').click( function (e) {
    e.preventDefault();
    var _this = $(this);

    _this.closest('.technology-partner-level-item__modal').find('.technology-partner-level-item__integration-details').show();
    _this.closest('.technology-partner-level-item__modal').find('.technology-partner-level-item__modal-content').hide();
  })

  $('.technology-partner-level-item__integration-details-close').click( function () {
    var _this = $(this);

    _this.closest('.technology-partner-level-item__modal').find('.technology-partner-level-item__integration-details').hide();
    _this.closest('.technology-partner-level-item__modal').find('.technology-partner-level-item__modal-content').show();
  })

  if ($('.view-id-tenable_news').length > 0) {

    var _this = $('.media-press-releases__pr-item-image'), _width = _this.width(), _newHeight = _width * 0.5625;

    $('.view-id-tenable_news').parent().prepend('<div class="view-id-tenable_news-style"><style type="text/css"> .media-press-releases__pr-item-image { height: '+_newHeight+'px; }</style></div>')
  }

  $( window ).resize(function() {
    if ($('.media-press-releases__pr-item-image').length > 0) {
      var _this = $('.media-press-releases__pr-item-image'), _width = _this.width(), _newHeight = _width * 0.5625;

      $('.view-id-tenable_news-style').html('<style type="text/css"> .media-press-releases__pr-item-image { height: '+_newHeight+'px; }</style>');
    }
  });


  if ($('.announcement-bar').length > 0) {
    var _this = $('.announcement-bar'), _height = _this.outerHeight(), _header = $('header[role=banner]'), _headerHight = _header.outerHeight(), _richmenu = $('.rich-menu'), _body = _this.next();

    if(current_width < 390){
      _height = _height - 20;
    }else if(current_width > 390 && current_width <= 844){
      _height = _height - 10;
    }

    _header.css({'top': _height+'px'});
    _body.css({'padding-top':  _height});
    _richmenu.css({'top': _richmenu.offset().top+_height+30+'px'});
  }

  $( window ).resize(function() {
    if ($('.announcement-bar').length > 0) {
      var _this = $('.announcement-bar'), _height = _this.outerHeight(), _header = $('header[role=banner]'), _headerHight = _header.outerHeight(), _richmenu = $('.rich-menu');

      _header.delay().css({'top': _height+'px'});
      _richmenu.delay().css({'top': _richmenu.offset().top+_height+'px'});
    }
  });

  if($('.certification-buy-page__tab-nav-item').length > 0 && window.location.hash) {
    var _target = window.location.hash, _this = $('.certification-buy-page__tab-nav-item'+window.location.hash), _thisIndex = _this.index(), _tabNavItems = _this.parent().find('.certification-buy-page__tab-nav-item'), _tabContentItems = _this.parent().parent().parent().find('.certification-buy-page__tab');
    _tabNavItems.removeClass('active');
    _tabContentItems.removeClass('active');
    _this.addClass('active');
    _this.parent().parent().parent().find('.certification-buy-page__tab:eq('+_thisIndex+')').addClass('active');
    if ($(window).width() <= 768) {
          $('html, body').animate({
              scrollTop: _this.parent().offset().top + _this.parent().height()
          }, 2000);
    }
  }
  $('.certification-buy-page__tab-nav-item').click( function () {
    var _this = $(this), _thisIndex = _this.index(), _tabNavItems = _this.parent().find('.certification-buy-page__tab-nav-item'), _tabContentItems = _this.parent().parent().parent().find('.certification-buy-page__tab');

    _tabNavItems.removeClass('active');
    _tabContentItems.removeClass('active');
    _this.addClass('active');
    _this.parent().parent().parent().find('.certification-buy-page__tab:eq('+_thisIndex+')').addClass('active');
    if ($(window).width() <= 768) {
          $('html, body').animate({
              scrollTop: _this.parent().offset().top + _this.parent().height()
          }, 2000);
    }
  });

  if($('.buy-page__tab-nav-item').length > 0 && window.location.hash) {
    var _target = window.location.hash, _this = $('.buy-page__tab-nav-item'+window.location.hash), _thisIndex = _this.index(), _tabNavItems = _this.parent().find('.buy-page__tab-nav-item'), _tabContentItems = $('.buy-page .buy-page__content-box').find('.buy-page__tab');
    _tabNavItems.removeClass('active');
    _tabContentItems.removeClass('active');
    _this.addClass('active');
    $('.buy-page .buy-page__content-box').find('.buy-page__tab:eq('+_thisIndex+')').addClass('active');
    if ($(window).width() <= 768) {
          $('html, body').animate({
              scrollTop: _this.parent().offset().top + _this.parent().height()
          }, 2000);
    }else{
      $('html, body').animate({
        scrollTop: _this.parent().offset().top - 100
      }, 500);
    }
  }
  $('.buy-page__tab-nav-item').click( function () {
    var _this = $(this), _thisIndex = _this.index(), _tabNavItems = _this.parent().find('.buy-page__tab-nav-item'), _tabContentItems = $('.buy-page .buy-page__content-box').find('.buy-page__tab');

    _tabNavItems.removeClass('active');
    _tabContentItems.removeClass('active');
    _this.addClass('active');
    $('.buy-page .buy-page__content-box').find('.buy-page__tab:eq('+_thisIndex+')').addClass('active');
    if ($(window).width() <= 768) {
          $('html, body').animate({
              scrollTop: _this.parent().offset().top + _this.parent().height()
          }, 2000);
    }else{
      $('html, body').animate({
        scrollTop: _this.parent().offset().top - 100
      }, 500);
    }
  });

  if($('.blog-index-container-related .views-element-container .blog-related-articles .view-content .blog-item').length < 3) {
    var relatedArticlesContainer = $('.blog-index-container-related .views-element-container .blog-related-articles .view-content'), tilesToCopy = 3 - relatedArticlesContainer.find('.blog-item').length, blogTitles = Array();

    $('.blog-index-container-related .views-element-container .blog-related-articles .blog-item').each( function(index, elem) {
      blogTitles[index] = $(this).find('h2 a').text();
    });

    for (var i=0; i<tilesToCopy; i++) {
      var tile = $('.blog-index-container-extra .views-element-container .blog-related-articles .view-content .blog-item:eq('+i+')').clone(), thisTitle = tile.find('h2 a').text();

      if (!blogTitles.includes(thisTitle)) {
        relatedArticlesContainer.append(tile);
      } else {
        tilesToCopy++;
      }
    }
  }

  $('.comparison-button').click( function (e) {
    e.preventDefault();
    var _this = $(this), _target = _this.data('target');

    $('.product-lobby__tab-container').removeClass('active');
    $('.comparison-button').removeClass('comparison-button--blue');
    _this.addClass('comparison-button--blue');
    $('.'+_target).addClass('active');
  });

  if ($('.comparison-button').length > 0 && window.location.hash) {
    var _target = window.location.hash.replace("#","");
    $('.product-lobby__tab-container').removeClass('active');
    $('.comparison-button').removeClass('comparison-button--blue');
    $('.comparison-button[data-target='+_target+']').addClass('comparison-button--blue');
    $('.'+_target).addClass('active');

    $('.comparison-button').click( function (e) {
      e.preventDefault();
      var _this = $(this), _target = _this.data('target');

      $('.product-lobby__tab-container').removeClass('active');
      $('.comparison-button').removeClass('comparison-button--blue');
      _this.addClass('comparison-button--blue');
      $('.'+_target).addClass('active');
    });
  }

  $('.c-comptable__selector-group a').click(function(){
    $(this).toggleClass('js-active');
    var numActive = $('.c-comptable__selector-group a.js-active').length;
    var product = $(this).attr('data-product');

    $('.c-comptable').addClass('js-active');
    $('.c-comptable').attr("data-active", numActive);
    $('.c-comptable').toggleClass('js-active--'+product);
    $('.c-comptable__row.header-row div#product-'+product).toggleClass('js-active');
    $('.c-comptable__row.footer-row div#footer-'+product).toggleClass('js-active');
    $('.c-comptable__row.header-row div.js-active, .c-comptable__row.footer-row div.js-active').removeClass('js-first js-last');
    $('.c-comptable__row.header-row div.js-active').first().addClass('js-first');
    $('.c-comptable__row.footer-row div.js-active').first().addClass('js-first');
    $('.c-comptable__row.header-row div.js-active').last().addClass('js-last');
    $('.c-comptable__row.footer-row div.js-active').last().addClass('js-last');

    if (numActive === 4) {
      $('.c-comptable__selector-group').addClass('js-max-selected');
    }
    if (numActive === 3) {
      $('.c-comptable__selector-group').removeClass('js-max-selected');
    }
    if (numActive === 0) {
      $('.c-comptable').removeClass('js-active');
    }

  });

  if ($('.js-set-compare-default').length > 0) {
    $('a.selector-one, a.selector-io, a.selector-cs').each( function () {
      $(this).toggleClass('js-active');
      var numActive = $('.c-comptable__selector-group a.js-active').length;
      var product = $(this).attr('data-product');

      $('.c-comptable').addClass('js-active');
      $('.c-comptable').attr("data-active", numActive);
      $('.c-comptable').toggleClass('js-active--'+product);
      $('.c-comptable__row.header-row div#product-'+product).toggleClass('js-active');
      $('.c-comptable__row.footer-row div#footer-'+product).toggleClass('js-active');
      $('.c-comptable__row.header-row div.js-active, .c-comptable__row.footer-row div.js-active').removeClass('js-first js-last');
      $('.c-comptable__row.header-row div.js-active').first().addClass('js-first');
      $('.c-comptable__row.footer-row div.js-active').first().addClass('js-first');
      $('.c-comptable__row.header-row div.js-active').last().addClass('js-last');
      $('.c-comptable__row.footer-row div.js-active').last().addClass('js-last');

      if (numActive === 4) {
        $('.c-comptable__selector-group').addClass('js-max-selected');
      }
      if (numActive === 3) {
        $('.c-comptable__selector-group').removeClass('js-max-selected');
      }
      if (numActive === 0) {
        $('.c-comptable').removeClass('js-active');
      }
    });
  }

  $('.media-room-nav a').click( function (e) {
    e.preventDefault();

    $('.media-room-nav a').removeClass('active');
    $(this).addClass('active');

  });

  var activeIndex = $('.inthenews__home-nav li').find('a.active').parent().index();
  $('.inthenews__home-content-container').find('.inthenews__home-content:eq('+activeIndex+')').addClass('active');

  if(current_width >= 768){
    var activeIndex = $('.inthenews__home-nav.desktop li').find('a.active').parent().index();
    $('.inthenews__home-content-container').find('.inthenews__home-content:eq('+activeIndex+')').addClass('active');

    $('.inthenews__home-nav.desktop li a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _index = _this.parent().index();

      $('.inthenews__home-nav.desktop li a').removeClass('active');
      _this.addClass('active');
      // $('.inthenews__home-nav.mobile option:eq('+_index+')').prop('selected', true);

      $('.inthenews__home-content').removeClass('active');
      $('.inthenews__home-content-container').find('.inthenews__home-content:eq('+_index+')').addClass('active');
    });
  }else{
    // var activeIndexmobile = $('.inthenews__home-nav.mobile').find(':selected').parent().index();
    // $('.inthenews__home-content-container').find('.inthenews__home-content:eq('+activeIndexmobile+')').addClass('active');

    $('.inthenews__home-nav.mobile').change( function (e) {

      var _this = $(this), _index = _this.parent().index();

      // $('.inthenews__home-nav.desktop li a').removeClass('active');
      // $('.inthenews__home-nav.desktop li:nth-child('+_this.val()+')').addClass('active');

      $('.inthenews__home-content').removeClass('active');
      $('.inthenews__home-content-container').find('.inthenews__home-content:eq('+_this.val()+')').addClass('active');
    });
  }

  $('.professional-services__service-slider-col a').click( function () {
    var _this = $(this), tabName = _this.data('tab');
    $('.professional-services__service-slider-slide-container').addClass('active');
    $('.professional-services__service-slider-slide').removeClass('active');
    $('.professional-services__service-slider-slide.'+tabName).addClass('active');
  });

  $('.professional-services__service-slider-slide-container a.close').click( function () {
    $(this).parent().removeClass('active');
  });

  $('.professional-services__service-slider-slide-container a.next').click( function () {
    var _current = $('.professional-services__service-slider-slide.active'), _next = $('.professional-services__service-slider-slide.active').next();
    if (!_next.hasClass('professional-services__service-slider-slide')) {
      _current.removeClass('active');
      $('.professional-services__service-slider-slide:first').addClass('active');
    } else {
      _current.removeClass('active');
      _next.addClass('active');
    }
  });

  $('.professional-services__service-slider-slide-container a.prev').click( function () {
    var _current = $('.professional-services__service-slider-slide.active'), _prev = $('.professional-services__service-slider-slide.active').prev();
    if (!_prev.hasClass('professional-services__service-slider-slide')) {
      _current.removeClass('active');
      $('.professional-services__service-slider-slide:last').addClass('active');
    } else {
      _current.removeClass('active');
      _prev.addClass('active');
    }
  });

  if ($(window).width() > 768) {
    $('svg.solution-diagram a').not('svg.solution-diagram a.svg-element-group').click( function(e) {
      e.preventDefault();
      var _this = $(this), dataName = _this.data('tab');
      $('svg.solution-diagram a').removeClass('active');
      _this.addClass('active');
      $('.solution-diagram-description').removeClass('active');
      $('.solution-diagram-description.'+dataName).addClass('active');
    });
    $('svg.solution-diagram a.svg-element-group').click( function(e) {
      e.preventDefault();
      var _this = $(this), dataName = _this.data('member');
      $('svg.solution-diagram a').removeClass('active');
      $("svg.solution-diagram a[data-tab='"+dataName+"']").addClass('active');
      $('.solution-diagram-description').removeClass('active');
      $('.solution-diagram-description.'+dataName).addClass('active');
    });
    $('svg.solution-diagram a.svg-element-group').hover( function() {
      var _this = $(this), dataName = _this.data('member');
      $('svg.solution-diagram a').removeClass('hover');
      $("svg.solution-diagram a[data-tab='"+dataName+"']").addClass('hover');
    }, function() {
      $('svg.solution-diagram a').removeClass('hover');
    });
    $('svg.solution-diagram a').hover( function() {
      $(this).addClass('hover');
    }, function() {
      $('svg.solution-diagram a').removeClass('hover');
    });
  } else {
    $('.solution-diagram-description').click( function (e) {
      $('.solution-diagram-description').removeClass('active');
      $(this).toggleClass('active');
    });
  }

  if ($('.featured-techpartners-item').length > 0) {
    $('.featured-techpartners-item__info:eq(0)').addClass('active');
  }

  $('.featured-partner-details').click( function (e) {
    e.preventDefault();
    _this = $(this),
    _title = _this.data('featured-partner'),
    _titleContentMatch = $('.technology-partner-item__mobile-info .technology-partner-item__content h3:contains('+_title+')').parent().parent(),
    _tileListing = _titleContentMatch.parent();

    $('.technology-partner-item').removeClass('active');
    $('.technology-partner-item__info').slideUp();
    _tileListing.parent().next().find('.technology-partner-item__info').html('<div class="technology-partner-item__info-close">X</div>'+_titleContentMatch.html());
    _tileListing.parent().next().find('.technology-partner-item__info').slideDown();
    _tileListing.addClass('active');

    setTimeout( function () {
      $([document.documentElement, document.body]).animate({
          scrollTop: _tileListing.offset().top - 100
      }, 1000);
    }, 350);
  })

  $('.featured-techpartners-item').click( function () {
    var _this = $(this),
        _index = _this.index(),
        _window = $(window),
        _mobileInfo = _this.find('.featured-techpartners-item__mobile-info'),
        _dekstopInfo = $('.featured-techpartners-item__info:eq('+_index+')'),
        _animateToHeight = _dekstopInfo.height() - $('.featured-techpartners-container').height() + 40,
        _featuredPartnersUI = $('.featured-techpartners'),
        _title = _this.find('.featured-techpartners-item__mobile-info h3').text(),
        _titleContentMatch = $('.technology-partner-item__mobile-info .technology-partner-item__content h3:contains('+_title+')').parent().parent(),
        _tileListing = _titleContentMatch.parent();

    if (_window.width() > 768) {
      $('.technology-partner-item').removeClass('active');
      $('.technology-partner-item__info').slideUp();
      _tileListing.parent().next().find('.technology-partner-item__info').html('<div class="technology-partner-item__info-close">X</div>'+_titleContentMatch.html());
      _tileListing.parent().next().find('.technology-partner-item__info').slideDown();
      _tileListing.addClass('active');

      setTimeout( function () {
        $([document.documentElement, document.body]).animate({
            scrollTop: _tileListing.offset().top - 100
        }, 1000);
      }, 350);
    } else {
      if (!_mobileInfo.is(":visible")) {
        _mobileInfo.slideDown();
      } else {
        _mobileInfo.slideUp();
      }
    }
  });

  $('.featured-techpartners-item__close').click( function () {
    var _window = $(window);

    if (_window.width() > 768) {
      $('.featured-techpartners-item, .featured-techpartners-item__info').removeClass('active');
    }
  });

  integrationPartnersTiles.init();

  if($('.blog-tabs').length > 0) {
    var blogPath = window.location.pathname;

    $('.blog-tabs__nav a').each( function () {
      var _this = $(this);
      if (_this.attr('href') === blogPath || _this.attr('href')+'/all' === blogPath) {
        _this.addClass('active');
      }
    });

  }

  if ($('.cybersecurity-guide').length > 0 && window.location.hash) {
    $(window).unbind('scroll');
    var hash = window.location.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top - ($('#site-nav').height() + 80)
    }, 800);
  }

  $('a.learn-more:not(.seo-template-tab-anchor), a.back-to-top').click( function (e) {
    var _this = $(this), id = _this.attr('href');
    if (id.startsWith("#")) {
      e.preventDefault();
      var scrollTarget = $(id), pos = scrollTarget.offset().top - 100;
      if(id === '#vulnerability-management-plans') {
        $('.seo-template__tabs .seo-template-tab-nav a').removeClass('active');
        $('.seo-template-tab-content').removeClass('active');
        $('.seo-template__tabs .seo-template-tab-nav a:eq(1)').addClass('active');
        $('.seo-template-tab-content:eq(1)').addClass('active');
      }
      $('body, html').animate({scrollTop: pos});
    }
  });

  $('.seo-template__tabs .seo-template-tab-nav a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _parent = _this.parent(), _index = _this.index();

      _parent.find('.active').removeClass('active');
      _parent.parent().find('.active').removeClass('active');

      _this.addClass('active');

      _parent.parent().find('.seo-template-tab-content:eq('+_index+')').addClass('active');
  });

  $('.seo-template-tab-anchor').click( function (e) {
    e.preventDefault();
    var _id = $(this).attr('href');

    $('.seo-template__tabs .seo-template-tab-content, .seo-template-tab-nav a').removeClass('active');
    $('.seo-template__tabs ' + _id).addClass('active');
    $('.seo-template-tab-nav a[data-id="' + _id + '"]').addClass('active');

    $('html, body').animate(
      {
        scrollTop: $($(this).attr('href')).offset().top - 180,
      },
      500,
      'linear'
    );
  });

  $('.seo-template__faq-item, .product-page__faq-item').click( function () {
    var _this = $(this);

    if (!_this.hasClass('open')) {
      _this.addClass('open');
      _this.find('.faq-item-answer').slideDown();
    } else {
      _this.removeClass('open');
      _this.find('.faq-item-answer').slideUp();
    }

  });

  $('.inner-tab-nav li a').click( function (e) {
    e.preventDefault();

    var _this = $(this), index = _this.parent().index();

    $('.inner-tab-nav li a').removeClass('active');

    _this.addClass('active');

    $('.inner-tab-nav li a').removeClass('active');

    _this.addClass('active');

    _this.parent().parent().parent().find('.inner-tab-nav-content').removeClass('active');

    _this.parent().parent().parent().find('.inner-tab-nav-content:eq('+index+')').addClass('active');

  });

  if ($('.inner-tab-nav').length > 0) {
    var searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('tab')) {
      $('.inner-tab-nav li a').removeClass('active');
      $('.inner-tab-nav-content').removeClass('active');
      $('.inner-tab-nav li a.'+searchParams.get('tab')).addClass('active');
      $('.inner-tab-nav-content.'+searchParams.get('tab')).addClass('active');
    }
  }

  $('.class-section__class-slider-title').click( function () {
    var _this = $(this);

    if (!_this.parent().hasClass('open')) {
      _this.parent().addClass('open');
      _this.parent().find('.class-section__class-slider-content').slideDown();
    } else {
      _this.parent().removeClass('open');
      _this.parent().find('.class-section__class-slider-content').slideUp();
    }

  });

  $('.seo-template__read-more a').click( function (e) {
    e.preventDefault();
    var _this = $(this);

    _this.parent().parent().find('.seo-template__slide-down-content').addClass('open');
    _this.parent().hide();
  });

  $('.vm-five-steps__section-tab').click( function () {
    var _thisTab = $(this), _thisContent = _thisTab.next();

    if(!_thisTab.hasClass('active')) {
      _thisTab.addClass('active');
    } else {
      _thisTab.removeClass('active');
    }

    if(!_thisContent.hasClass('active')) {
      _thisContent.slideDown( 300, function () {
        _thisContent.addClass('active');
      });
    } else {
      _thisContent.slideUp( 300, function () {
        _thisContent.removeClass('active');
      });
    }

  });

  var vmNav = $('.vm-five-steps__nav'), waypoints = $('a.waypoint');
  if (vmNav.length) {
    var vmNavTop = (vmNav.offset().top-100);
  }
  $(window).scroll( function () {

    $('body').addClass('vm-scrolled');

    if ($(window).scrollTop() > vmNavTop) {
      vmNav.css({'position': 'fixed', 'top': '80px', 'right': '0', 'left': '0', 'z-index': '15'});
      vmNav.find('span, .vm-five-steps__content').slideUp();
      vmNav.addClass('collapsed');
    }

    waypoints.each( function (index) {
      var _thisWaypoint = $(this), waypointTop = (_thisWaypoint.offset().top-50);

      vmNavTopLoc = (vmNav.offset().top-50);

        if (waypointTop < vmNavTopLoc && !vmNav.hasClass('click-closed')) {

          vmNav.find('a.active').removeClass('active');
          vmNav.find('a:eq('+index+')').addClass('active');
        }

    });

    if ($(window).scrollTop() < vmNavTop) {
      vmNav.css({'position': 'relative', 'top': '0'});
      if (!vmNav.hasClass('click-closed')) {
        vmNav.find('span, .vm-five-steps__content').slideDown();
      }
      vmNav.removeClass('collapsed');
      setTimeout( function() {
        vmNav.removeClass('click-closed');
      }, 500);
    }
  });

  if ($('.vm-five-steps__nav-intro').length && $('.vm-five-steps__nav nav a.active').length === 0) {
    setTimeout( function() {
      if (!$('body').hasClass('vm-scrolled')) {
        $('html, body').animate({
          scrollTop: $('.vm-five-steps__nav-intro').offset().top - 44
        }, 1000);
      }
    }, 5000);
  }

  $('.vm-five-steps__nav nav a').click( function (e) {
    e.preventDefault();
    var _this = $(this), target = _this.attr('href'), targetTrimA = target.split('#'), vmNavScrollOffset = 24;

    vmNav.find('a.active').removeClass('active');
    _this.addClass('active');

    if (vmNav.hasClass('collapsed')) {
        $('html, body').animate({
          scrollTop: $('a[name="'+targetTrimA[1]+'"]').offset().top - vmNavScrollOffset
        }, 1000);
      } else {
        vmNavScrollOffset = 64;
        setTimeout( function() {
          $('html, body').animate({
            scrollTop: $('a[name="'+targetTrimA[1]+'"]').offset().top - vmNavScrollOffset
          }, 1000);
        }, 500);
        vmNav.find('span, .vm-five-steps__content').slideUp();
        vmNav.addClass('collapsed').addClass('click-closed');
      }
  });

    $('.tenable-product-page__faq-item').click( function () {
      var _this = $(this), slideOut = _this.find('.tenable-product-page__faq-a');

      if (!_this.hasClass('open')) {
        _this.addClass('open');
        slideOut.slideDown();
      } else {
        _this.removeClass('open');
        slideOut.slideUp();
      }
    });

    $('.portal-anchors li').click( function () {
      var _this = $(this), _parent = _this.parent(), _index = _this.index();

      _parent.find('.active').removeClass('active');
      _parent.parent().find('.active').removeClass('active');

      _this.addClass('active');
    });

    setInterval( function () {
      $('#binary').find('span').first().remove();
      var binaryContent = '';
      var operator;
      var thisVal = ' ';
      for(var i=0;i<50;i++) {
        operator = Math.floor(Math.random()*3);
        if (operator === 0) {
          thisVal += '0';
        }
        if (operator === 1) {
          thisVal += '1';
        }
        if (operator === 2) {
          thisVal += '&nbsp;';
        }
      }
      $('#binary').append('<span>'+thisVal+'</span>');
    }, 100);

    $('html').removeClass('no-js').addClass('js');

    $('.grid-listing__label').on("mouseover", function () {
      var _this = $(this), _parent = _this.parent();
      _parent.find('.grid-listing__tooltip').addClass('show');
    });

    $('.grid-listing__item').on("mouseout", function () {
      var _this = $(this);
      _this.find('.grid-listing__tooltip').removeClass('show');
    });

    $('.home-slideout-tab__arrow').click( function () {
      var _this = $(this), _parent = _this.parent().parent();

      if (!_parent.hasClass('show')) {
        _parent.addClass('show');
      } else {
        _parent.removeClass('show');
      }
    });

    $('.tenable-product-page--insights-tt__control a').click( function (e) {
      e.preventDefault();
      var _th = $(this), ind = _th.parent().index();

      if (!_th.hasClass('active')) {
        _th.parent().parent().find('a.active').removeClass('active');
        _th.parent().parent().parent().parent().find('.tenable-product-page--insights-tt__screen-tt').removeClass('active');
        _th.addClass('active');
        _th.parent().parent().parent().parent().find('.tenable-product-page--insights-tt__screen-tt:eq('+ind+')').addClass('active');
      }
    });

    $('.tenable-product-page--insights-tt__control.was a').click( function (e) {
      e.preventDefault();
      var _th = $(this), ind = _th.parent().index();
      var data_img = _th.attr('data-img');

      _th.parent().parent().parent().parent().find('.img-screen').attr('src', '');
      _th.parent().parent().parent().parent().find('.img-screen').attr('src', data_img);

      if (!_th.hasClass('active')) {
        _th.parent().parent().find('a.active').removeClass('active');
        _th.parent().parent().parent().parent().find('.tenable-product-page--insights-tt__screen-tt').removeClass('active');
        _th.addClass('active');
        _th.parent().parent().parent().parent().find('.tenable-product-page--insights-tt__screen-tt:eq('+ind+')').addClass('active');
      }

    });

    $('.edge-speakers-grid__speaker').click( function () {
      var _this = $(this);

      if(!_this.hasClass('open-speaker')) {
        _this.addClass('open-speaker');
        $('.edge-speaker-modal-backdrop').addClass('active');
      } else {
        _this.removeClass('open-speaker');
        $('.edge-speaker-modal-backdrop').removeClass('active');
      }
    });

    // 2020 Principles Grid Index
    $('.grid-index__trigger').click(function(){
        $('.grid-index__item').removeClass('js-active');
        $(this).parent('.grid-index__item').addClass('js-active');
    });
    $('.grid-index__overlay-trigger').click(function(){
        $('.grid-index__item').removeClass('js-active');
    });

    $('.edge-session-speaker').click( function () {
      var _this = $(this), modal = _this.find('.edge-session-speaker__speaker-modal'), modalBackdrop = $('.edge-speaker-modal-backdrop');

      if(!modal.hasClass('modal-open')) {
        modal.addClass('modal-open');
        modalBackdrop.addClass('active');
      } else {
        modal.removeClass('modal-open');
        modalBackdrop.removeClass('active');
      }
    });

    $('.home-customer-tabs__nav a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _index = _this.index(), _parentParent = _this.parent().parent();
      _parentParent.find('.home-customer-tabs__content').removeClass('active');
      _this.parent().find('a').removeClass('active');
      _parentParent.find('.home-customer-tabs__content:eq('+_index+')').addClass('active');
      _this.addClass('active');
    });

    if($('.sticky-social-widget').length > 0 && $(window).width() > 1399) {
      var lastScrollTop = 0,
          stickyWidget = $('.sticky-social-widget'),
          titleContainer = $('.title .container'),
          titleContainerPos = titleContainer.offset();

          if (titleContainer.length === 0) {
            titleContainer = $('.blog-header .container');
            titleContainerPos = titleContainer.offset();
          }

      stickyWidget.css({'left': (titleContainerPos.left - 100)+'px'});
      $(window).on('scroll', function () {

        if ($( window ).width() > 1399) {
          var pos = $(window).scrollTop(),
              stickyWidgetPos = stickyWidget.position(),
              top = stickyWidgetPos.top,
              triggerOffset = 200,
              footer = $('#site-footer'),
              footerPos = footer.position();

              if ($('.blog-header').length > 0) {
                footer = $('.blog-index-subscribe');
                footerPos = footer.position();
              }

              if (pos > lastScrollTop) {
                if (pos > (top - triggerOffset)) {
                  stickyWidget.addClass('stick');
                }
              } else {
                if (pos <= triggerOffset) {
                  stickyWidget.removeClass('stick');
                }
              }
              if (pos >= (footerPos.top - 500)) {
                stickyWidget.fadeOut(200);
              }
              if (pos < (footerPos.top - 500)) {
                stickyWidget.fadeIn();
              }
              lastScrollTop = pos;
        }
      });

      $(window).on('resize', function () {
        var lastScrollTop = 0,
          stickyWidget = $('.sticky-social-widget'),
          titleContainer = $('.title .container');

          if (titleContainer.length === 0) {
            titleContainer = $('.blog-header .container');
          }

          titleContainerPos = titleContainer.offset();
          stickyWidget.css({'left': (titleContainerPos.left - 100)+'px'});

          if ($(window).width() <= 1399) {
            stickyWidget.css({'left': '0'});
          }

        });
    }

  if($('.try-section-nav').length > 0 && $(window).width() > 1199) {
    $('.try-section-nav ul li a').on('click', function (e) {
      e.preventDefault();

      $('html, body').animate(
        {
          scrollTop: $($(this).attr('href')).offset().top,
        },
        500,
        'linear'
      );
    });
      var lastTryScrollTop = 0,
          stickyTryWidget = $('.try-section-nav'),
          titleTryContainer = $('#site-nav'),
          titleTryContainerPos = titleTryContainer.offset();

      $(window).on('scroll', function () {
          var pos = $(window).scrollTop(),
              stickyWidgetPos = stickyTryWidget.position(),
              top = stickyWidgetPos.top,
              triggerOffset = 200,
              footer = $('#site-footer'),
              footerPos = footer.position();
              if ($(window).width() > 1199) {
                $('.scroll-section').each( function () {
                  var _this = $(this), _thisPos = _this.position(), _thisId = _this.attr('id');

                  if (pos > _thisPos.top) {

                    stickyTryWidget.find('li').removeClass('active');
                    stickyTryWidget.find('li.'+_thisId).addClass('active');
                  }
                });

                if (pos > lastTryScrollTop) {
                  if (pos > (top - triggerOffset)) {
                    stickyTryWidget.addClass('stick');
                  }
                } else {
                  if (pos <= triggerOffset) {
                    stickyTryWidget.removeClass('stick');
                  }
                }
                if (pos >= (footerPos.top - 500)) {
                  stickyTryWidget.fadeOut();
                }
                if (pos < (footerPos.top - 500)) {
                  stickyTryWidget.fadeIn();
                }
                lastScrollTop = pos;
              }
      });

      $(window).on('resize', function () {

        if ($(window).width() > 1199) {
          $('.try-section-nav').show();
        } else {
          $('.try-section-nav').hide();
        }
      });

    }

    $('.product-diagram-mobile__media-item').click( function () {
      var _this = $(this);

      if (!_this.hasClass('open')) {
        _this.find('.product-diagram-mobile__media-item-content').slideDown();
      } else {
        _this.find('.product-diagram-mobile__media-item-content').slideUp();
      }
      _this.toggleClass('open');
    });

    $(window).on('resize', function () {

          if ($(window).width() <= 1399) {
            $('.sticky-social-widget').removeClass('stick').css({'left': '0px'});
          }
        });

    $('a.inner-scroll').on('click', function (e) {
      e.preventDefault();

      $('html, body').animate(
        {
          scrollTop: $($(this).attr('href')).offset().top - 200,
        },
        500,
        'linear'
      );
    });

    $(window).on('scroll', function () {

      if ($( window ).width() > 1024) {
        var pos = $(window).scrollTop();
        $('.home-slideout-tab').removeClass('show');
        $('.home-slide').each( function () {
          var _this = $(this),
              _thisPos = _this.position(),
              top = _thisPos.top,
              triggerOffset = 300,
              siteFooter = $('#site-footer'),
              siteFooterPos = siteFooter.position(),
              siteFooterTop = siteFooterPos.top,
              homePageNav = $('.home-sidebar-navigation');

          if (pos > (top - triggerOffset )) {

            if (!_this.hasClass('products-listing') && !_this.hasClass('research-listing')) {
              _this.addClass('animate');
            }

            var index = $('.home-slide.animate').length - 1;

            $('.home-sidebar-navigation ul li').removeClass('active').removeClass('pulse');
            $('.home-sidebar-navigation ul li:eq('+index+')').addClass('active').addClass('pulse');
          } else {
            _this.removeClass('animate');
          }

          if (pos > (siteFooterTop - triggerOffset )) {
            homePageNav.fadeOut();
          } else {
            homePageNav.fadeIn();
          }

        });
      }
    });

    $(window).on('scroll', function () {

      if ($( window ).width() > 768) {
        var pos = $(window).scrollTop();
        $('.home__content-hex').each( function () {
          var _this = $(this),
              _thisPos = _this.position(),
              top = _thisPos.top,
              triggerOffset = 500,
              siteFooter = $('#site-footer'),
              siteFooterPos = siteFooter.position(),
              siteFooterTop = siteFooterPos.top;

          if (pos > (top - triggerOffset )) {
            _this.addClass('activate');
          } else {
            _this.removeClass('activate');
          }

        });
      }
    });

    if ($( window ).width() > 1024) {
        var pos = $(window).scrollTop();
        $('.home-slide').each( function () {
          var _this = $(this),
              _thisPos = _this.position(),
              top = _thisPos.top,
              triggerOffset = 300,
              siteFooter = $('#site-footer'),
              siteFooterPos = siteFooter.position(),
              siteFooterTop = siteFooterPos.top,
              homePageNav = $('.home-sidebar-navigation');

          if (pos > (top - 300)) {
            if (!_this.hasClass('products-listing') && !_this.hasClass('research-listing')) {
              _this.addClass('animate');
            }

            var index = $('.home-slide.animate').length - 1;
            console.log(index);
            $('.home-sidebar-navigation ul li').removeClass('active').removeClass('pulse');
            $('.home-sidebar-navigation ul li:eq('+index+')').addClass('active').addClass('pulse');
          } else {
            _this.removeClass('animate');
          }

          if (pos > (siteFooterTop - triggerOffset )) {
            homePageNav.fadeOut();
          } else {
            homePageNav.fadeIn();
          }

      });
    }

    if ($( window ).width() <= 1024) {
      $('.home-slideout-tab').removeClass('show');
    }

    setTimeout( function () {
      $('.home-sidebar-navigation ul li').each( function () {
        var _this = $(this);
        var _thisIndex = _this.index();

        setTimeout( function () {
          if (!$('.home-slide').hasClass('active')) {
            _this.removeClass('active').find('a.filled').removeClass('filled').addClass('filled-flash');
          }
        }, ( (_thisIndex*75) / 0.8) );

      });
      setTimeout( function () {
        if (!$('.home-slide').hasClass('active')) {
          $('.home-sidebar-navigation ul li a').removeClass('filled-flash');
          var index = $('.home-slide.animate').length - 1;
          $('.home-sidebar-navigation ul li:eq('+index+')').addClass('active').addClass('pulse');
        }
      }, 1000);
    }, 2000);

    if ($( window ).width() > 1024) {
      $('.home-slide.home-mast').addClass('animate');
    } else {
      $('.home-slide').addClass('animate');
    }

    $('.home-sidebar-navigation ul li a').click( function (e) {
      e.preventDefault();
      var _this = $(this), slideClass = _this.data('slide'), slide = $('.home-slide.'+slideClass);

      _this.parent().parent().find('li').removeClass('active').removeClass('animate').removeClass('pulse');
      _this.parent().addClass('active').addClass('pulse');

      $('.home-slide').removeClass('active').removeClass('animate');

      //$('.home-slide.'+slideClass).addClass('active').addClass('animate');

      $('html, body').animate({
        scrollTop: slide.offset().top
      }, 1000, 'swing', function () {
        slide.addClass('animate');
      });

    });


    $('a.home-show-poducts-list').click( function (e) {
      e.preventDefault();
      $('.home-slide.products-listing').addClass('active');
      if ($( window ).width() <= 1024) {
        $('html, body').animate({
          scrollTop: $('.home-slide.products-listing').offset().top
        }, 1000);
      }
    });

    $('a.home-show-research-list').click( function (e) {
      e.preventDefault();
      $('.home-slide.research-listing').addClass('active');
      if ($( window ).width() <= 1024) {
        $('html, body').animate({
          scrollTop: $('.home-slide.research-listing').offset().top
        }, 1000);
      }
    });

    $('.close-home-panel').click( function (e) {
      e.preventDefault();
      $(this).parent().parent().removeClass('active');
    });

    $('.nessus-slider li').click( function () {
      var _this = $(this), _index = _this.index();
      _this.parent().find('.nessus-slider__content').slideUp(300, function () {
        _this.parent().find('li').removeClass('active');
      });
      _this.find('.nessus-slider__content').slideDown(300, function () {
        _this.addClass('active');
      });
      _this.parent().parent().parent().find('.nessus-slider__images img').removeClass('active');
      _this.parent().parent().parent().find('.nessus-slider__images img:eq('+_index+')').addClass('active');
      let vidCheck = $('.nessus-slider__images a:eq(' + _index + ')');
      $('.nessus-slider__images .vidyardvideo').addClass('hidden');
      if (vidCheck.hasClass('hidden')) {
        vidCheck.removeClass('hidden');
        vidCheck.find('.vidyard-lightbox-image').addClass('active');
      }
    });

    $('.pci-dss-more-info').click( function (e) {
      e.preventDefault();
      var activeTab = $(this).data('tab');

      $('.solution-tabs__container').removeClass('active');
      $('.solution-tabs__tabs li').removeClass('active');
      $('.solution-tabs__container:eq('+activeTab+')').addClass('active');
      $('.solution-tabs__tabs li:eq('+activeTab+')').addClass('active');
      $('#solution-tabs').slideDown();

      setTimeout(function () {
        var scrollTo = $('#solution-tabs').offset().top - 100;
        $('html, body').animate({
          scrollTop: scrollTo
        }, 1000);}, 350);



    });


    $('.product-lobby-tabs a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _index = _this.index();
      $('.product-lobby-tabs a').removeClass('active');
      $(this).addClass('active');
      $('.product-lobby-tabs__content').removeClass('active');
      $('.product-lobby-tabs__content:eq('+_index+')').addClass('active');
    });

    if (window.location.search.length > 0) {
      var urlParams = new URLSearchParams(window.location.search), productTabValue = urlParams.get('product-tab');

      if(urlParams.has('product-tab') === true) {
        $('.product-lobby-tabs a').removeClass('active');
        $('.product-lobby-tabs__content').removeClass('active');
        $('.product-lobby-tabs a.'+productTabValue).addClass('active');
        $('.product-lobby-tabs__content:eq('+$('.product-lobby-tabs a.active').index()+')').addClass('active');
      }
    }


    $('.solution-tabs__tabs li').click( function (e) {
      e.preventDefault();
      var _this = $(this), _index = _this.index();
      _this.parent().parent().find('.solution-tabs__container').removeClass('active');
      _this.parent().find('li').removeClass('active');
      _this.parent().parent().find('.solution-tabs__container:eq('+_index+')').addClass('active');
      _this.addClass('active');
    });

    $('.nessus-video-tabs__tabs-container a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _index = _this.index();
      _this.parent().parent().find('.nessus-video-tabs__video-container a').removeClass('active');
      _this.parent().find('a').removeClass('active');
      _this.parent().parent().find('.nessus-video-tabs__video-container a:eq('+_index+')').addClass('active');
      vidyardEmbed.api.addReadyListener((_, player) => {
        var players = VidyardV4.players;
        players[0].pause();
        players[1].pause();
        players[2].pause();
        players[3].pause();
        players[4].pause();
      }, )
      _this.addClass('active');
    });

    $('.product-resources .product-resources__tabs a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _index = _this.index();
      _this.parent().parent().find('.container .product-resources__content.active').removeClass('active');
      _this.parent().find('a').removeClass('active');
      _this.parent().parent().find('.container .product-resources__content:eq('+_index+')').addClass('active');
      _this.parent().parent().find('.container .product-resources__content:eq('+_index+')').addClass('active');
      _this.addClass('active');
    });

    $('.product-lobby-tiles__container .product-lobby-tiles__tabs a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _index = _this.index();
      _this.parent().parent().find('.product-lobby-tiles__tabs-content.active').removeClass('active');
      _this.parent().find('a').removeClass('active');
      _this.parent().parent().find('.product-lobby-tiles__tabs-content:eq('+_index+')').addClass('active');
      _this.addClass('active');
    });

    var documentLocationURL = document.location.pathname;
    if (documentLocationURL.indexOf('tiekinetix') >= 0) {
      $('body').addClass('tiekinetix');
    }

    /**
     * Begin blog banner modification
    **/
    $('.blog-item.featured-content.featured-post').html($('.blog-index-banner').html());
    $('.blog-item.featured-content.featured-post').attr('style', $('.blog-index-banner').attr('style'));
    $('.blog-index-banner').hide();
    $('.blog-item.featured-content.featured-post').addClass('blog-index-banner');

    /**
     * Prevent blocking load by loading web fonts until they're ready
     * https://www.zachleat.com/web-fonts/demos/fout-with-class.html
     */

    async function loadSingleFont(family, weight, style) {
      const font = new FontFaceObserver(family, { weight: weight, style: style });
      try {
        return await font.load(null, 5000);
      } catch (err) {
        console.error(`Failed to load ${family} with ${weight} and ${style}`, err);
        return await Promise.resolve();
      }
    }

    // Optimization for Repeat Views
    if( sessionStorage.foutFontsLoaded ) {
      document.documentElement.classList.add('fonts-loaded');
    } else {
      const allFonts = [
        { family: 'aeonik pro', weight: 100, style: 'normal' },
        { family: 'aeonik pro', weight: 100, style: 'italic' },
        { family: 'aeonik pro', weight: 200, style: 'normal' },
        { family: 'aeonik pro', weight: 200, style: 'italic' },
        { family: 'aeonik pro', weight: 300, style: 'normal' },
        { family: 'aeonik pro', weight: 300, style: 'italic' },
        { family: 'aeonik pro', weight: 400, style: 'normal' },
        { family: 'aeonik pro', weight: 400, style: 'italic' },
        { family: 'aeonik pro', weight: 500, style: 'normal' },
        { family: 'aeonik pro', weight: 500, style: 'italic' },
        { family: 'aeonik pro', weight: 600, style: 'normal' },
        { family: 'aeonik pro', weight: 600, style: 'italic' },
        { family: 'aeonik pro', weight: 700, style: 'normal' },
        { family: 'aeonik pro', weight: 700, style: 'italic' },
        { family: 'radix', weight: 300, style: 'normal' },
        { family: 'radix', weight: 400, style: 'normal' },
        { family: 'instrument sans', weight: 400, style: 'normal'},
        { family: 'instrument sans', weight: 600, style: 'normal' },
      ];

      const fontPromises = allFonts.map(font => loadSingleFont(font.family, font.weight, font.style));

      Promise.all(fontPromises).then(() => {
        document.documentElement.classList.add('fonts-loaded');
        // Optimization for Repeat Views
        sessionStorage.foutFontsLoaded = true;
      });
    }

    /**
     * Title size set based on how long title is
    */
    var title = $('.title h1.giga'),
        titleLength = title.text().length;

    if (titleLength < 32) {
      title.removeClass('giga');
    } else if (titleLength > 100) {
      title.removeClass('giga').addClass('mega');
    }

    //Stat counter
    function commaSeparateNumber(val){
      while (/(\d+)(\d{3})/.test(val.toString())){
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    }

    function animateNums() {
      $('.stat').each(function () {
        $(this).prop('Counter',0).animate({
          Counter: $(this).text()
        }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            $(this).text(commaSeparateNumber(Math.ceil(now)));
          }
        });
      });
    }

    if(window.location.pathname === '/') {
      animateNums();
    }

    $('.animate-count, .js-animate-count').each( function () {
      var _this = $(this), _prepend = _this.data('prepend'), _append = _this.data('append');

      if (_prepend === undefined) {
        _prepend = '';
      }

      if (_append === undefined) {
        _append = '';
      }

      _this.prop('Counter', 0).animate({
        Counter: _this.data('number')
      }, {
        duration: 4000,
        easing: 'swing',
        step: function (now) {
          _this.text(_prepend+commaSeparateNumber(Math.ceil(now))+_append);
        }
      });

    });

    // Smooth scroll to anchor
    $('.smooth-scroll').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top + -62
          }, 1000);
          return false;
        }
      }
    });

    // Auto lightbox blog body images
    $('.blog__body p > img').each(function() {
      console.info($(this));
      $(this).wrap('<a href="' + $(this).attr('src') + '" class="lightbox"></a>');
    });

    // Magnific Popup

    //Single
    $('.lightbox, .fancybox, a[rel=lightbox]').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }
    });


    // Gallery
    $('.lightbox-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        verticalFit: false,
        titleSrc: function(item) {
          var caption = item.el.attr('title'),
              shareURL = 'https://www.tenable.com' + item.el.attr('href'),
              tweetURL = 'https://twitter.com/intent/tweet' + '?text=' + caption + ' ' + shareURL,
              fbURL = 'https://www.facebook.com/sharer/sharer.php?u=' + shareURL,
              linkedInURL = 'https://www.linkedin.com/shareArticle?mini=true&url=' + shareURL + '&title=' + caption;

          return caption + ' &middot; <a href="' + tweetURL + '" target="_blank"><span class="icon-twitter"></span></a><a href="' + fbURL + '" target="_blank"><span class="icon-facebook"></span></a><a href="' + linkedInURL + '" target="_blank"><span class="icon-linkedin"></span></a>';
        }
      }
    });

    //Blog Item
    $('.blog-item').each( function () {
      $(this).css({'cursor': 'pointer'});
      $(this).click( function () {
        window.location.href = $(this).find('a').attr('href');
      });
    });

    // Get more information blog section
    var blogMoreInfo = $('.blog__body h3:contains("Get more information")');
    if (blogMoreInfo.length === 0) {
      blogMoreInfo = $('.blog__body h2:contains("Learn more")');
    }
    if (blogMoreInfo.length > 0 && !blogMoreInfo.parent().parent().hasClass('blog-see-also')) {
      var blogMoreInfoHTML = '<div class="blog-see-also"><div class="col-sm-12"><h3 class="active">'+blogMoreInfo.html()+'</h3><ul>'+blogMoreInfo.next().html()+'</ul></div></div>';
      blogMoreInfo.next().remove();
      blogMoreInfo.replaceWith(blogMoreInfoHTML);
    }

    // Swap blog intro and image
    var blogIntro = $('.blog__body p:eq(0)'), blogImg = $('.blog-post-image'), blogUpdate = $('.blog-update');

    if (blogImg.length > 0) {
      blogImg.before('<p class="blog-intro">'+blogIntro.html()+'</p>');
      blogIntro.remove();

      $('.blog-update-view-log').click( function (e) {
        e.preventDefault();

        $('html, body').animate(
          {
            scrollTop: $('#blog-change-log').offset().top - 100,
          },
          500,
          'linear'
        );

      });

    }

    if (blogUpdate.length > 0) {
      blogImg.after('<div class="blog-update">'+blogUpdate.html()+'</div>');
      blogUpdate.remove();

      $('.blog-update-view-log').click( function (e) {
        e.preventDefault();

        $('html, body').animate(
          {
            scrollTop: $('#blog-change-log').offset().top - 100,
          },
          500,
          'linear'
        );

      });
    }

    // Responsive blog & product faq tables
    $('.blog__body table:not(.exclude-table), .product-page__faq-item table, .view-id-training_classes table, .cert-details-table, .c-faq-item__answer table').basictable();

    // Video
    $('.lightbox-video').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      iframe: {
        markup: '<div class="mfp-iframe-scaler">'+
            '<div class="mfp-close"></div>'+
            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay"></iframe>'+
          '</div>',
        patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: 'https://www.youtube.com/embed/%id%?autoplay=1'
          }
        },
        srcAction: 'iframe_src',
      }
    });

    //Process datalayer for opening closing modals with magnificpopup

    function dataLayerModal(oMModal, status, navType) {
      let prodName, modalType, eventName;
      if (oMModal !== undefined && oMModal !== null) {
        const oMModalId = oMModal.id;
        const mTry = oMModal.querySelector('.try-tab.js-active') !== null;
        const mBuy = oMModal.querySelector('.buy-tab.js-active') !== null;
        if (mTry) {
          modalType = 'Try';
        } else if (mBuy) {
          modalType = 'Buy';
        } else {
          modalType = undefined;
        }
        switch (oMModalId) {
          case 'one-eval':
            prodName = 'tenable_one'
            break;
          case 'tenableio':
          case 'tenableio-2part':
          case 'tenableio-4part':
            prodName = 'vulnerability_management'
            break;
          case 'lumin-eval':
            prodName = 'lumin'
            break;
          case 'tenable-cs':
            prodName = 'cloud_security'
            break;
          case 'asm-eval':
            prodName = 'attack_surface_management'
            break;
          case 'expert':
            prodName = 'nessus_expert'
            break;
          case 'nessus':
            prodName = 'nessus_professional'
            break;
          case 'tenable-sc-eval':
            prodName = 'security_center'
            break;
          case 'ad-eval':
            prodName = 'identity_exposure'
            break;
          case 'ot-eval':
            prodName = 'ot_security'
            break;
          case 'tenableio-was':
            prodName = 'web_app_scanning'
            break;
          case 'enclave':
            prodName = 'enclave_security'
            break;
          case 'tenable-newsletter':
            prodName = 'newsletter'
            break;
          case 'handraiser':
            prodName = 'cyber_asset_management'
            break;
          case 'slgcs-grant':
            prodName = 'slgcs-grant'
            break;
          case 'patch-mgmt':
            prodName = 'patch-management'
            break;
          default:
        }
        if (status == 'open') {
          eventName = 'open_modal';
        } else if (status = 'close') {
          eventName = 'close_modal';
        }
        window.dataLayer.push({
          'event': eventName,
          'modal_product': prodName,
          'modal_tab': modalType,
          'nav_type': navType
        });
      }
      return;
    }

    //Content
    $('.lightbox-content').magnificPopup({
        type:'inline',
        midClick: true,
        callbacks: {
          open: function() {
            const oMModal = document.querySelector('.mfp-content > .try-buy-modal');
            const sourceElement = this.st.el;
            let navType;
            if (sourceElement !== undefined && sourceElement !== null) {
              navType = $(sourceElement).data('nav-type');
            }
            dataLayerModal(oMModal, 'open', navType);
          },
          beforeClose: function() {
            const oMModal = document.querySelector('.mfp-content > .try-buy-modal');
            const sourceElement = this.st.el;
            let navType;
            if (sourceElement !== undefined && sourceElement !== null) {
              navType = $(sourceElement).data('nav-type');
            }
            dataLayerModal(oMModal, 'close', navType);
          }
        }
    });

    $('.lightbox-image').magnificPopup({
        type: 'image',
        midClick: true,
        image: {
          verticalFit: true
        }
    });

    // Event lightboxes
    $('.lightbox-event').each(function(){
        $(this).magnificPopup({
            items: {
                src: $(this).siblings('.event-modal'),
                type: 'inline'
            }
        });
    });

    $('.lightbox-event-featured').each(function(){
        $(this).magnificPopup({
            items: {
                src: $(this).closest('.events-listing').find('.event-modal'),
                type: 'inline'
            }
        });
    });

    $('.edge-session').magnificPopup({
        type:'inline',
        mainClass: 'lightbox-partner',
        midClick: true
    });

    // Partner Inline Content
    $('.lightbox-partner-view').magnificPopup({
        type:'inline',
        mainClass: 'lightbox-partner',
        midClick: true
    });

    //Nessus Download table download swap
    $('#download-swap, #download-swap-2').click(function(){
      $('.compare').hide();
      $('.downloads').show();
      window.scrollTo(0, 0);
      return false;
    });

    // Eval and Nessus Home Reverse CAPTCHA

    $('#submit-nessus-eval').hover(function() {
      this.form.robot.value = 'human';
    }, function() {});

    $('#nessus-eval').keypress(function(evt) {
      return !(evt.which === 13 && evt.target.type !== 'textarea');
    });


    $('#submit-pvs-eval').hover(function() {
      this.form.robot.value = 'human';
    }, function() {});

    $('#pvs-eval').keypress(function(evt) {
      return !(evt.which === 13 && evt.target.type !== 'textarea');
    });


    $('#submit-nessus-home').hover(function() {
      this.form.robot.value = 'human';
    }, function() {});

    $('#nessus-home-reg').keypress(function(evt) {
      return !(evt.which === 13 && evt.target.type !== 'textarea');
    });

    $('tbody tr:even').addClass('odd');

    //Fitvids
    $('.onehalf, .onethird, .twothirds, .threefourths, .video-player, .field-name-body').fitVids();

    //Vidyard Flexible Embed
    $(window).on('load resize',function(){
      $(".vidyard_player > span").each (function (index) {
        // Maintain 16:9 aspect ratio
        $(this).height($(this).width()*(9/16));
      });
    });

    function newAccordion(el) {
      el.addClass('accordion');
      el.find('h3:first-child').addClass('active');
      el.find('> div:not(:first)').hide();

      el.find('h3').click(function(){
        if($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).next().slideUp();
        } else {
          el.find('h3').removeClass('active');
          el.find('> div').slideUp().toggleClass('active');
          $(this).toggleClass('active');
          $(this).next().slideToggle();
        }
        return false;
      });
    }

    newAccordion($('#accordion'));
    newAccordion($('#accordion-2'));

    if($('.multi-accordion').length){
      $('.multi-accordion').each(function(){
        newAccordion($(this));
      })
    }

    if($('.open-accordion').length){
      newAccordion($('.open-accordion'));
    }

    //vertical tabs
    $(window).resize(function(){
    if($('.vertical-tabs').innerWidth() > 898) {
        if($('div.selected').length){
        }else{
            $('div.box:first').addClass('selected');
        }
      }
    });

    $('ul.checklist-select li').click(function() {
      var selectID = $(this).attr('id');
      $('ul.checklist-select li').removeClass('active');
      $(this).addClass('active');
      $('div.box').removeClass('selected');
      $('.' + selectID + '-box').addClass('selected');
    });

    // Accordion to tabs
    $('#tab-nav').children('li').first().children('a').addClass('active')
      .next().addClass('tab-open').show();

    $('#tab-nav').on('click', 'li > a', function() {

      if (!$(this).hasClass('active')) {

        $('#tab-nav .tab-open').removeClass('tab-open').hide();
        $(this).next().toggleClass('tab-open').toggle();

        $('#tab-nav').find('.active').removeClass('active');
        $(this).addClass('active');
        return false;
      } else {
        return false;
      }
    });

    // Generate Podcast Player from link
    var mp3     = $('.node-blog-post a[href$=".mp3"]');
    var mp3link = $(mp3).attr("href");

    $(mp3).wrap('<div id="player" />');
    $('#player').append('<audio controls="controls"><source src="'+mp3link+'" /></audio>');

    function init() {
      window.addEventListener('scroll', function(e){

        var distanceY = window.pageYOffset || document.documentElement.scrollTop,
            shrinkOn = 1,
            pageHeader = $("header[role=banner]");
            pageSubmenu = $('.submenu-item');
            mobMenu = $('#mob-menu');

        if (distanceY > shrinkOn) {
          pageHeader.addClass('scrolled');
          pageSubmenu.addClass('scrolled');
          mobMenu.addClass('scrolled');
        } else {
          if (pageHeader.has('scrolled')) {
            pageHeader.removeClass('scrolled');
            pageSubmenu.removeClass('scrolled');
            mobMenu.removeClass('scrolled');
          }
        }
      });

      var distanceY = window.pageYOffset || document.documentElement.scrollTop,
            shrinkOn = 1,
            pageHeader = $("header[role=banner]");
            pageSubmenu = $('.submenu-item');

      if (distanceY > shrinkOn) {
        pageHeader.addClass('scrolled');
        pageSubmenu.addClass('scrolled');
      }
    }

    init();

    // Footer accordion
    $('.footer-nav h3').click(function(){
      $(this).toggleClass('open');
      $(this).siblings('ul').toggleClass('hidden');
      return false;
    });

    // Dropdowns
    $('#language-trigger').mouseover(function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $('#login-trigger').removeClass('active');
      $('.login-menu').removeClass('is-open');
      $('.language-menu').addClass('is-open');
      $('.rich-menu').removeClass('active');
      $('header.main-nav-2021').addClass('hovered');
      $('.main-nav__item').removeClass('active');
    });

    $('#login-trigger').mouseover(function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $('#language-trigger').removeClass('active');
      $('.language-menu').removeClass('is-open');
      $('.login-menu').addClass('is-open');
      $('.rich-menu').removeClass('active');
      $('header.main-nav-2021').addClass('hovered');
      $('.main-nav__item').removeClass('active');
    });

    $('.language-menu, .login-menu').mouseleave( function () {
      $(this).delay(300).removeClass('active');
      $('.login-menu, .language-menu').removeClass('is-open');
      $('header.main-nav-2021').removeClass('hovered');
      $('.main-nav__item').removeClass('active');
    });

  $('#login-trigger').mouseleave( function () {
    $(this).delay(300).removeClass('active');
    $('.login-menu, .language-menu').removeClass('is-open');
  });
  $('.login-menu').mouseenter( function () {
    $(this).addClass('active');
    $('.login-menu').addClass('is-open');
  });

  $('#language-trigger').mouseleave( function () {
    $(this).delay(300).removeClass('active');
    $('.login-menu, .language-menu').removeClass('is-open');
  });
  $('.language-menu').mouseenter( function () {
    $(this).addClass('active');
    $('.language-menu').addClass('is-open');
  });

    // Blog Dropdown
    var blogDropdownMenu = document.querySelector('.blog-dropdown');
    var blogNavTrigger = document.querySelector('.blog-nav-trigger');

    if(blogDropdownMenu) {
      blogNavTrigger.addEventListener('click', function(e){
         e.preventDefault();
         blogDropdownMenu.classList.toggle('hidden');
      });
    }

    // Blog search Dropdown
    var blogSearch = document.querySelector('#blog-search'),
        blogSearchInput = document.querySelector('#blog-search-input');

    /* if(blogSearchTrigger) {
      blogSearchTrigger.addEventListener('click', function(e){
        e.preventDefault();
        blogSearchDropdown.classList.toggle('hidden');
        blogSearchInput.focus();
      });
    } */
    $('#blog-search input[type=submit]').click( function () {
      e.preventDefault();
      window.location = 'https://www.tenable.com/search/node/' + $('#blog-search-input').value() + ' type:blog_post';
    });
    /* blogSearch.addEventListener('submit', function(e){
      e.preventDefault();
      window.location = 'https://www.tenable.com/search/node/' + blogSearchInput.value + ' type:blog_post';
    }); */

    // Toggle Nessus FAQ Questions
    $(".question-section h4").click(function(){
        $(this).parent().toggleClass('expanded');
    });

    //homepage feature products widget
    $('.need-product-select a').click(function(e){
      e.preventDefault();
      $(this).find('img').toggleClass('down');
      $('.main-products').toggleClass('hidden');
      $('.widget-products').toggleClass('hidden');
    });

    $('.widget-products .solutions li a').click(function(e){
      e.preventDefault();
      $('.widget-products .solutions li a img').addClass('hidden');
      $(this).find('img').removeClass('hidden');
      var productsId = $(this).attr('href');
      $('.solutionProducts').addClass('hidden');
      $(productsId).removeClass('hidden');
    });

    // Enable floating sidebar on Nessus FAQ
    $('.nessus-faq-nav-container').theiaStickySidebar({
      additionalMarginTop: 100
    });

    // Page scroll behavior for the Nessus FAQ page
    $('.nessus-faq-nav ul li a').click( function (e) {
      e.preventDefault();

      var anchorName = $(this).attr('href');

      var target = $(anchorName).parent();

      $('html, body').animate({
        scrollTop: target.offset().top - 100
      }, 800);

    });

    $(".expandable-content").click(function(){
        var showObject = $(this).find('.agenda-schedule__item-content-expand');
        var showObjectParent = $(this);
        var hideObject = $(this).find('.agenda-schedule__item-content-hide');

        showObjectParent.toggleClass('expanded');
        if (showObjectParent.hasClass('expanded')) {
          showObject.slideDown();
          hideObject.slideUp();
        } else {
          showObject.slideUp();
          hideObject.slideDown();
        }
    });

    $(".track-session").click(function(){
        var showObject = $(this).find('.track-session__content');
        var showObjectParent = $(this);

        showObjectParent.toggleClass('expanded');
        if (showObjectParent.hasClass('expanded')) {
          showObject.slideDown();
        } else {
          showObject.slideUp();
        }
    });

    $(".solutions-page-nav-section .solutions-nav a").click(function(e){
      e.preventDefault();
      var tabId = $(this).attr('id');
      $('.solutions-options > div').hide();
      $('.solutions-options #'+tabId).show();
      $(".solutions-page-nav-section .solutions-nav a").removeClass('active');
      $(this).addClass('active');
    });

    if(window.location.hash && window.location.hash.indexOf('industries') > -1) {
      $('.solutions-options > div').hide();
      $('.solutions-options #industries').show();
      $(".solutions-page-nav-section .solutions-nav a").removeClass('active');
      $('#industries').addClass('active');
    }

    $(".product-diagram.platform .product-diagram-desktop .media-item").on( "mouseenter", function(e){
      $(".product-diagram.platform .product-diagram__media .product-diagram__info h3").html($(this).find('h3').html());
      $(".product-diagram.platform .product-diagram__media .product-diagram__info p").html($(this).find('p.item-content').html());
      $(".product-diagram.platform .product-diagram__media .product-diagram__info").css('opacity','1');
      $(".product-diagram.platform .product-diagram__content").css('opacity','0');
    });

    $(".product-diagram.platform .product-diagram-desktop .media-item").on( "mouseleave", function(e){
      $(".product-diagram.platform .product-diagram__media .product-diagram__info").css('opacity','0');
      $(".product-diagram.platform .product-diagram__content").css('opacity','1');
    });

    var courseCount = 1;
    $('.tenable-course__tile').each( function () {

      var Total = $('.tenable-course__tile').length;

      $(this).find('.tenable-course__count').html(courseCount + '/' + Total);
      courseCount++;

    });



    var $Masonry = $('.customers-container.masonry .customers-container__customers').isotope({
      layoutMode: 'fitRows',
      fitRows: {
        gutter: 28,
        initLayout: false
      },
      initLayout: false
    });

    function filterCustomers() {
      var filterParams = '';

      $('.customers-filter').find(":selected").each( function () {
        var _this = $(this);
        filterParams =  filterParams +'.'+_this.val();
      });

      if (filterParams.length > 0) {
        this.filterParams = filterParams;
      } else {
        filterParams = '*';
      }

      $Masonry.isotope({ filter: filterParams });
    }

  if ($('.customers-filter').length > 0 && window.location.hash) {
    var filterHashValue = window.location.hash.substring(1), filterInputOptions = $('.customers-filter > option');
    filterInputOptions.each ( function () {
      var _this = $(this);
      if (_this.val() == filterHashValue) {
        _this.prop('selected', true);
        $('html, body').animate({
              scrollTop: $('.customers-container.masonry').offset().top - ($('#site-nav').height() + 100)
        }, 2000);
        filterCustomers();
      }
    });
  }

  $('.customers-filter').change( function () {
    var _this = $(this);
    if(_this != 'all'){
      $('.customers-filter-product .reset-filters').css('display','flex');
    }

    filterCustomers();
  });

  $('.customers-filter-product .reset-filters').click(function(e){
    e.preventDefault();
    $('.customers-filter').val('all');
    $('.customers-filter-product .reset-filters').css('display','none');

    filterCustomers();
  });

  filterCustomers();

  $(window).resize(function() {
    filterCustomers();
  });



    var $courseGrid = $('#Courses').isotope();

    function applyFilters() {
      var filterParams = '';

      $('.course-filter.active').each( function () {
        var _this = $(this);
        if (_this.hasClass('active')) {
          filterParams =  filterParams +'.'+_this.data('filter');
        }
      });

      if (filterParams.length > 0) {
        this.filterParams = filterParams;
      } else {
        filterParams = '*';
      }

      $courseGrid.isotope({ filter: filterParams });
    }

    $('.course-info').click( function (e) {
        e.preventDefault();
        var _parent = $(this).parent().parent().parent();

        $('.tenable-course__tile').removeClass('show-tile');

        if (!_parent.hasClass('show-tile') && !$(this).hasClass('close-slider')) {
          _parent.addClass('show-tile');
          $(this).addClass('close-slider');

          $courseGrid.isotope({ filter: '.show-tile' });

          $courseGrid.on( 'arrangeComplete', function() {
            var Slider = $('.show-tile .tenable-course__sideout');
            if($(window).width() > 768) {
              Slider.css('height', _parent.height()+'px');
              Slider.fadeIn(600);
            } else {
              Slider.slideDown();
            }
          });
        } else {
          var Slider = _parent.find('.tenable-course__sideout');
          if($(window).width() > 768) {
            Slider.hide();
          } else {
            Slider.slideDown();
          }
          $('.tenable-course__tile').removeClass('show-tile');
          $(this).removeClass('close-slider');
          applyFilters();
        }

    });


      if ($(window).width() <= 991) {
        $('.key-roles-tab.active').find('.key-roles-accordion').slideDown();
        $('.key-roles-tab').click( function () {
            var _this = $(this), _index = _this.index();
            if (_this.hasClass('active')) {
              _this.find('.key-roles-accordion').slideUp();
              _this.removeClass('active')
            } else {
              _this.addClass('active');
              _this.find('.key-roles-accordion').slideDown();
            }

            _this.parent().find('.key-roles-tab').not('.key-roles-tab:eq('+_index+')').removeClass('active');

            $('.key-roles-tab').each( function () {
              var _this = $(this);
              if (!_this.hasClass('active')) {
                _this.find('.key-roles-accordion').slideUp()
              }
            });

        });
      } else {
        $('.key-roles-tab').click( function () {
          var _this = $(this), _index = _this.index();

          _this.parent().find('.key-roles-tab.active').removeClass('active');
          _this.addClass('active');
          _this.parent().parent().find('.key-roles-item.active').removeClass('active');
          _this.parent().parent().find('.key-roles-item:eq('+_index+')').addClass('active');
        });
      }

    $( window ).resize( function() {
        $('.key-roles-tab').click( function () {
          var _this = $(this), _index = _this.index();

          _this.parent().find('.key-roles-tab.active').removeClass('active');
          _this.addClass('active');
          _this.parent().parent().find('.key-roles-item.active').removeClass('active');
          _this.parent().parent().find('.key-roles-item:eq('+_index+')').addClass('active');
        });
    });

    // Edge mobile nav toggle
    /* $('.mobile-togglen').click( function () {
      var _this = $(this);
      _this.toggleClass('expanded');
      if (_this.hasClass('expanded')) {
        _this.parent().parent().find('.mobile-toggle a').slideDown();
      } else {
        _this.parent().parent().find('.mobile-toggle a').slideUp();
      }
    }); */

    $('.tenable-course__close').click( function () {

      var Slider = $(this).parent();
      //Slider.hide();
      if($(window).width() > 768) {
        Slider.hide();
      } else {
        Slider.slideUp();
      }
      $('.tenable-course__tile').removeClass('show-tile');
      applyFilters();
    });

    $('.agenda-schedule__item-content').click( function (e) {
      var _this = $(this);
      var _parent = _this.parent();

      _parent.find('.agenda-schedule__item-content-arrow').toggleClass('expanded');
      if (_parent.find('.agenda-schedule__item-content-arrow').hasClass('expanded')) {
        _parent.find('.agenda-schedule__item-content-hidden').slideDown();
      } else {
        _parent.find('.agenda-schedule__item-content-hidden').slideUp();
      }
    });

    $('.agenda-tabs__nav li').click( function () {

      var _this = $(this), index = _this.index();

      _this.parent().find('li').removeClass('active');
      _this.addClass('active');
      _this.parent().parent().parent().find('.agenda-schedule').removeClass('active');
      _this.parent().parent().parent().find('.agenda-schedule:eq('+index+')').addClass('active');

    });

    // Handles sorting on thenable Edge courses
    $('.course-filter').click( function (e) {
      e.preventDefault();
      var _this = $(this);
      _this.parent().find('.course-filter').removeClass('active');
      _this.toggleClass('active');
      $('.tenable-course__tile').removeClass('show-tile');
      $('.course-info').removeClass('close-slider');
      $('.tenable-course__sideout').hide();
      applyFilters();

    });

    // // Main dropdown
    // $(document).click(function(){
    //  $('#products, #support, #company').removeClass('active');
    //  $('#submenu-products, #submenu-support, #submenu-company').slideUp();
    // });
    //
    // $('#products').click(function(e){
    //   e.stopPropagation();
    //  $(this).toggleClass('active');
    //   $('#support, #company, #search, #solutions').removeClass('active');
    //   $('#submenu-support, #submenu-company').slideUp();
    //   $('#submenu-products').slideToggle();
    //   return false;
    // });
    //
    // $('#support').click(function(e){
    //  e.stopPropagation();
    //  $(this).toggleClass('active');
    //   $('#products, #company, #search, #solutions').removeClass('active');
    //   $('#submenu-products, #submenu-company').slideUp();
    //   $('#submenu-support').slideToggle();
    //   return false;
    // });
    //
    // $('#company').click(function(e){
    //  e.stopPropagation();
    //  $(this).toggleClass('active');
    //   $('#support, #products, #search, #solutions').removeClass('active');
    //   $('#submenu-products, #submenu-support').slideUp();
    //   $('#submenu-company').slideToggle();
    //   return false;
    // });

  // Toggle menu on mobile
    $("#menu-icon").click(function(){
        $("#mobilenav").toggleClass('visible');
    });

    // 2017 Partner Select controls
    $(".partner-select__trigger").click(function(){
        $(".partner-select__trigger, .partner-select__item").removeClass('js-active');
    });
    $(".partner-select__trigger.platinum").click(function(){
        $(this).add(".partner-select__item.platinum").addClass('js-active');
    });
    $(".partner-select__trigger.gold").click(function(){
        $(this).add(".partner-select__item.gold").addClass('js-active');
    });
    $(".partner-select__trigger.silver").click(function(){
        $(this).add(".partner-select__item.silver").addClass('js-active');
    });
    $(".partner-select__trigger.bronze").click(function(){
        $(this).add(".partner-select__item.bronze").addClass('js-active');
    });

    // 2017 Featured Partner Select controls
    $(".featured-partner-select__trigger").click(function(){
        $(".featured-partner-select__item").removeClass('js-active');
        $(".featured-partner-select__trigger").attr("class", "featured-partner-select__trigger");
    });
    $(".featured-partner-select__trigger.discover").click(function(){
        $(this).add(".featured-partner-select__item.discover").addClass('js-active');
        $(this).attr("class", "featured-partner-select__trigger js-active");
    });
    $(".featured-partner-select__trigger.assess").click(function(){
        $(this).add(".featured-partner-select__item.assess").addClass('js-active');
        $(this).attr("class", "featured-partner-select__trigger js-active");
    });
    $(".featured-partner-select__trigger.analyze").click(function(){
        $(this).add(".featured-partner-select__item.analyze").addClass('js-active');
        $(this).attr("class", "featured-partner-select__trigger js-active");
    });
    $(".featured-partner-select__trigger.fix").click(function(){
        $(this).add(".featured-partner-select__item.fix").addClass('js-active');
        $(this).attr("class", "featured-partner-select__trigger js-active");
    });
    $(".featured-partner-select__trigger.measure").click(function(){
        $(this).add(".featured-partner-select__item.measure").addClass('js-active');
        $(this).attr("class", "featured-partner-select__trigger js-active");
    });
    $(".featured-partner-select__trigger.measure").click(function(){
        $(this).add(".featured-partner-select__item.measure").addClass('js-active');
        $(this).attr("class", "featured-partner-select__trigger js-active");
    });

    // 2017 Technology Partner Select controls
    $(".tech-select__trigger").mouseover(function(){
        $(".tech-select__trigger, .tech-select__item").removeClass('js-active');
        var num = $(this).attr('class').match(/\d+$/)[0];
        $(this).add('.item--'+num).addClass('js-active');
    });

    // 2017 IO Platform toggle controls
    $(".io-platform__trigger.trigger-01, .io-platform__item.item-01, .io-platform__arrow.arrow-01 img").hover(function(){
        $(".io-platform").toggleClass('js-active-01');
    });
    $(".io-platform__trigger.trigger-02, .io-platform__item.item-02, .io-platform__arrow.arrow-02 img").hover(function(){
        $(".io-platform").toggleClass('js-active-02');
    });
    $(".io-platform__trigger.trigger-03, .io-platform__item.item-03, .io-platform__arrow.arrow-03 img").hover(function(){
        $(".io-platform").toggleClass('js-active-03');
    });
    $(".io-platform__trigger.trigger-04, .io-platform__item.item-04, .io-platform__arrow.arrow-04 img").hover(function(){
        $(".io-platform").toggleClass('js-active-04');
    });

    // 2017 Benefit toggle controls
    $(".benefit-toggle__trigger").removeAttr('href').click(function(){
        $(".benefit-toggle__trigger, .benefit-toggle__item").removeClass('js-active');
        var num = $(this).attr('class').match(/\d+$/)[0];
        $(this).add('.benefit-toggle__item.item-'+num).addClass('js-active');
    });

    if ($('.home-announcement-slider ul li').length > 1) {
      $('.home-announcement-slider').unslider({
        arrows: false,
        autoplay: true,
        infinite: true,
        delay: 6500
      });
    }

    if ($('.home-announcement-slider ul li').length > 1) {
      $('.home-announcement-slider').unslider({
        arrows: false,
        autoplay: true,
        infinite: true,
        delay: 6500
      });
    }

    $('.nessus-pro-carousel .container .nessus-pro-carousel__container').unslider({
      arrows: false,
      autoplay: true,
      infinite: true,
      delay: 6500
    });

    if ($('.product-quote-slider li').length > 1) {
      $('.product-quote-slider').unslider({
        autoplay: true,
        infinite: true,
        delay: 6500
      });
    }

    if ($('.careers-slider ul li').length > 1) {
      $('.careers-slider').unslider({
          arrows: false,
          autoplay: true,
          infinite: true,
          delay: 6500
      });
    }

    if ($('.research-page__carousel-slide-container ul li').length > 1) {
      $('.research-page__carousel-slide-container').unslider({
          arrows: true,
          autoplay: true,
          infinite: true,
          delay: 10000
      });
    }

    //Tech Support Photo Slider
    if ($('.techSupport-slider ul li').length > 1) {
      $('.techSupport-slider').unslider({
          arrows: false,
          autoplay: true,
          infinite: true,
          delay: 6500
      });
    }

    if ($('.t1-resource-bar__slider ul li').length > 1) {
      $('.t1-resource-bar__slider').unslider({
        dots: true,
        arrows: true,
        autoplay: true,
        animation: 'vertical',
        infinite: true,
        delay: 6500
      });
    }

    if ($('.t1-slider-container ul li').length > 1) {
      var heroSlider = $('.t1-slider-container').unslider({
          dots: false,
          arrows: false,
          autoplay: true,
          animation: 'fade',
          infinite: true,
          delay: 7500
      });

      $('.t1-slider-container').on('unslider.change', function() {
        var classList = $(this).find('li.unslider-active').attr('class');
        var classArr = classList.split(/\s+/);
        var animation = $(this).find('.animate-on-slide-in-view')

        $('.slider-nav-item').removeClass('js-active');
        $('.slider-nav-item.'+classArr[0]).addClass('js-active');

        $('.animate-on-slide-in-view').addClass('stop-anim').removeClass('animated fadeInRightSmall');
        $(this).find('li.unslider-active .animate-on-slide-in-view').removeClass('stop-anim').width();
        $(this).find('li.unslider-active .animate-on-slide-in-view').addClass('animated fadeInRightSmall');
      })

      $('.slider-nav-item a').click(function(e){
        e.preventDefault();
        var slideNumber = $(this).data('slide');
        $( ".unslider-nav li[data-slide='"+slideNumber+"']" ).trigger( "click" );
      });

    }
  if ($('.testimonal-slider__slider').length > 0) {
    var unslider = $('.testimonal-slider__slider').unslider({
      dots: false,
      arrows: false,
      autoplay: true,
      infinite: true,
      delay: 6600,
    });
    $('.testimonal-slider__slider .slider-arrow').click(function(e) {
      e.preventDefault();
      var fn = this.className.split(' ')[1];

      //  Either do unslider.data('unslider').next() or .prev() depending on the className
      unslider.data('unslider')[fn]();
    });
  }

  if ($('.t1-cards__slider ul li').length > 1) {
    $('.t1-cards__slider').unslider({
      dots: false,
      arrows: true,
      autoplay: true,
      infinite: true,
      delay: 6600,
    });
  }



    if ($('.slider ul li').length > 1) {
      $('.slider').unslider({
        arrows: false
      });
    }

    $('.platform-feature').viewportChecker({
        classToAdd: 'js-animate',
        offset: 350
    });

    // 2017 drop down menu
    /* $(document).click(function(){
        $('.rich-menu').removeClass('js-active');
    });
    $(".main-nav__item.has-menu > a").removeAttr('href');
    $(".main-nav__item.has-menu").click(function(e){
        e.stopPropagation();
        $(".rich-menu").removeClass('js-active');
        $(this).find(".rich-menu").toggleClass('js-active');
    }); */

    // 2018 mobile menu

      $("#menu-icon").click( function () {
        //$("#mob-menu").show();
        $('#mob-menu').removeAttr('style');
        $("#mob-menu").mmenu({
          extensions  : [ "shadow-panels", "fx-panels-slide-100", "border-none", "fullscreen" ],
          navbars   : {
            content : [ "prev", "title", "close" ],
            height  : 1
          }}, { });

        $('#mob-menu').addClass('mm-menu_opened');
        $('#site-nav').addClass('mm-open');
        $('html').addClass('mm-wrapper_opened mm-wrapper_blocking mm-wrapper_background mm-wrapper_opening');

        if($('.mob-menu.topbanner-visible').length){
          var topbanner_size = $('#site-nav > .nav-topbar').height();
          var main_hero_size = $('#site-nav > .nav-wrapper').outerHeight();
          $('#mob-menu').css({'top': topbanner_size + main_hero_size});
        }
      });
      $('#mob-menu').css({'z-index': '2000'});

     $('.mm-btn_close').click( function () {
       $('#mob-menu').removeClass('mm-menu_opened');
       $('#site-nav').removeClass('mm-open');
       $('html').removeClass('mm-wrapper_opened mm-wrapper_blocking mm-wrapper_background mm-wrapper_opening');
     });



    // 2018 rich menus

    $('.rich-menu__menu.main-menu-tabs li a.tab-control').mouseover( function (e) {
      var _this = $(this);
      var tabName = _this.data('tab');
      e.preventDefault();

     //alert(tabName);

      _this.parent().parent().parent().find('.main-menu-tabs li a').each( function () {
        $(this).removeClass('active');
      });
      _this.parents('.rich-menu').find('.rich-menu__menu-container').each( function () {
        $(this).removeClass('active');
        if ($(this).hasClass(tabName)) {
          $(this).addClass('active');
        }
      });

      _this.addClass('active');

    });
    
    $('.main-nav__item.has-menu').mouseover( function (e) {
      e.preventDefault();
      var _this = $(this);
      var menuName = _this.data('menu');
      $('header.main-nav-2021').addClass('hovered');
      $('.main-nav__item').removeClass('active');
      _this.addClass('active');


      $('.rich-menu').each( function () {

        if ($(this).hasClass(menuName)) {
          $(this).toggleClass('active');
        } else {
          $(this).removeClass('active');
        }
      });

      $('#login-trigger, #language-trigger').removeClass('active');
      $('.language-menu, .login-menu').removeClass('is-open');
      var topbanner_size = $('#site-nav > .nav-topbar').height();
      var main_hero_size = $('#site-nav > .nav-wrapper').outerHeight();
      
      if($('.site-nav--primary.topbanner-visible').length){
        var initialHeroHeight = topbanner_size + main_hero_size + 5
        $('.rich-menu.active').css({'top': initialHeroHeight});
        $(window).scroll(function (e) {
          if (!$('.site-nav--primary.topbanner-visible.scrolled').length) {
            $('.rich-menu.active').css({'top': topbanner_size + main_hero_size - 7});
          }
          if($(this).scrollTop() == 0){
            $('.rich-menu.active').css({'top': initialHeroHeight});
          }
        });
      }

    });

  $('.main-nav__item.no-menu').mouseover( function (e) {
    $('.rich-menu').removeClass('active');
    $('.main-nav__item').removeClass('active');
    $('#login-trigger, #language-trigger').removeClass('active');
    $('.language-menu, .login-menu').removeClass('is-open');

  });

    $('.rich-menu').mouseleave( function () {
      $(this).delay(300).removeClass('active');
      $('header.main-nav-2021').removeClass('hovered');
      $('.main-nav__item').removeClass('active');
    });

    $('.main-nav__item.has-menu').mouseleave( function () {
      if (!$('.rich-menu.active').hasClass('active')) {
        $('header.main-nav-2021').delay(300).removeClass('hovered');
        $(this).removeClass('active');
      }
    });


  // Nonav hack for Tie Kinetix and Lookbook
  if(window.location.hash === '#nonav') {
    document.body.classList.add('no-navigation');
  }

    // 2017 Generic tab controls
    // $('body').on("click", ".js-tab", function() {
    //     var num_id = $(this).attr('class').match(/tab-(\d+)/)[1];
    //     $('.js-tab, .js-tab-content').removeClass('js-active');
    //     $(this).add('.content-'+num_id).addClass('js-active');
    // });

    // Instanced version of above
    $('.js-tab-wrap .js-tab').click(function(e){
        // e.preventDefault();
        var num_id = $(this).attr('class').match(/tab-(\d+)/)[1];
        $(this).parents('.js-tab-wrap').find('.js-tab, .js-tab-content').removeClass('js-active').removeAttr('href');
        $(this).addClass('js-active');
        $(this).closest('.js-tab-wrap').find('.content-'+num_id).addClass('js-active');
        $(this).parents('.js-tab-wrap').attr('data-active', num_id);
    });

    $('.js-tab-wrap .js-tab.on-hover').hover(function(){
        var num_id = $(this).attr('class').match(/tab-(\d+)/)[1];
        $(this).parents('.js-tab-wrap').find('.js-tab, .js-tab-content').removeClass('js-active');
        $(this).addClass('js-active');
        $(this).closest('.js-tab-wrap').find('.content-'+num_id).addClass('js-active');
        $(this).parents('.js-tab-wrap').attr('data-active', num_id);
    });
    // For second set of tabs on Awards page
    $('.js-tab-wrap-two .js-tab').click(function(e){
        e.preventDefault();
        var num_id = $(this).attr('class').match(/tab-(\d+)/)[1];
        $(this).parents('.js-tab-wrap-two').find('.js-tab, .js-tab-content').removeClass('js-active').removeAttr('href');
        $(this).addClass('js-active');
        $(this).closest('.js-tab-wrap-two').find('.content-'+num_id).addClass('js-active');
        $(this).parents('.js-tab-wrap-two').attr('data-active', num_id);
    });
    // Auto select tab if href matches page anchor
    $(function () {
        var hash = $.trim( window.location.hash );

        if (hash) {
            $('.js-tab[href$="'+hash+'"]').trigger('click');
        }
    });

    // Fix for try/buy modal
    $('.vm-buy-link').click(function(){
        $('.tenableio-vm .js-tab, .tenableio-vm .js-tab-content').removeClass('js-active');
        $('.tenableio-vm .buy-tab, .tenableio-vm .js-tab-content.buy').addClass('js-active');
    });
    $('.vm-try-link').click(function(){
        $('.tenableio-vm .js-tab, .tenableio-vm .js-tab-content').removeClass('js-active');
        $('.tenableio-vm .try-tab, .tenableio-vm .js-tab-content.try').addClass('js-active');
    });
    $('.cs-buy-link').click(function(){
        $('.tenableio-cs .js-tab, .tenableio-cs .js-tab-content').removeClass('js-active');
        $('.tenableio-cs .buy-tab, .tenableio-cs .js-tab-content.buy').addClass('js-active');
    });
    $('.cs-try-link').click(function(){
        $('.tenableio-cs .js-tab, .tenableio-cs .js-tab-content').removeClass('js-active');
        $('.tenableio-cs .try-tab, .tenableio-cs .js-tab-content.try').addClass('js-active');
    });
    $('.was-buy-link').click(function(){
        $('.tenableio-was .js-tab, .tenableio-was .js-tab-content').removeClass('js-active');
        $('.tenableio-was .buy-tab, .tenableio-was .js-tab-content.buy').addClass('js-active');
    });
    $('.was-try-link').click(function(){
        $('.tenableio-was .js-tab, .tenableio-was .js-tab-content').removeClass('js-active');
        $('.tenableio-was .try-tab, .tenableio-was .js-tab-content.try').addClass('js-active');
    });
    $('.try-nessus-pro').click(function(){
        $('.nessus-pro .js-tab, .nessus-pro .js-tab-content').removeClass('js-active');
        $('.nessus-pro .try-tab, .nessus-pro .js-tab-content.try').addClass('js-active');
    });
    $('.buy-nessus-pro').click(function(){
        $('.nessus-pro .js-tab, .nessus-pro .js-tab-content').removeClass('js-active');
        $('.nessus-pro .buy-tab, .nessus-pro .js-tab-content.buy').addClass('js-active');
    });
    $('.try-nessus-expert').click(function(){
        $('.nessus-expert .js-tab, .nessus-expert .js-tab-content').removeClass('js-active');
        $('.nessus-expert .try-tab, .nessus-expert .js-tab-content.try').addClass('js-active');
    });
    $('.buy-nessus-expert').click(function(){
        $('.nessus-expert .js-tab, .nessus-expert .js-tab-content').removeClass('js-active');
        $('.nessus-expert .buy-tab, .nessus-expert .js-tab-content.buy').addClass('js-active');
    });

    // 2017 Generic trigger
    $('.js-trigger').removeAttr('href').click(function(){
        $('.js-target, .js-trigger').toggleClass('js-active');
    });

    //2017 Comparison Table control
    $('.ctable__toggle').removeAttr('href').click(function(){
        $(this).parents('.ctable__row').toggleClass('js-active');
    });

    $('.ctable__heading .ctable__toggle').removeAttr('href').click(function(){
        $(this).parents('.ctable').find('.ctable__inner').slideToggle();
        $(this).parents('.ctable__heading').toggleClass('js-active');
    });

    $('.ctable__col').click(function() {
        $('.ctable__col').removeClass('js-show-content');
        $(this).toggleClass('js-show-content');
    });

    $('.ctable__hcontent').click(function( event ) {
        event.stopPropagation();
        $(this).parents('.ctable__col').removeClass('js-show-content');
    });

    // Contact us map, select first child
    $('.location').click(function() {
        $('.location').removeClass('js-active');
    });
    $('.locale-heading').click(function() {
        $('.first').addClass('js-active');
    });

    //Apply placeholders to form based of input name. Delayed for marketo load time
    setTimeout(function() {
      const placeholderInputs = $(".apply-placeholders input");
      const placeholderTextareas = $(".apply-placeholders textarea");

      function applyPlaceholders() {
        const placeholderText = $("label[for='" + $(this).attr('id') + "']").first().text();
        $(this).attr("placeholder", placeholderText);
      }

      $.each(placeholderInputs, applyPlaceholders);
      $.each(placeholderTextareas, applyPlaceholders);
    }, 3000);

    //Add active class to gauze.js button when clicked
    $('.my-filters button').click(function() {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });

    /* Nessus Product Page 2020 Redesign */

    $('.nessus-pro-page .pop-up-button').on("click touch", function () {
      $('html').addClass("popupactive");
      $('.nessus-pro-page .pop-up-main').fadeIn(300);
      $(".nessus-pro-page .pop-up-main .pop-up-container iframe").attr("src", $(this).attr('data-video-url'));
      return false;
    });
    $('.nessus-pro-page .pop-up-main span,.pop-up-main').on("click touch", function () {
      $('html').removeClass("popupactive");
      $('.nessus-pro-page .pop-up-main').hide(0);
      $(".nessus-pro-page .pop-up-main .pop-up-container iframe").attr("src", "");
      return false;
    });
    setTimeout(function () {
      $(".nessus-pro-page .form-box .confirmation-box svg").replaceWith('<img src="/themes/custom/tenable/img/products/nessus/thanks_img.svg">');
    }, 1000);
    var check_form_button = setInterval(function () {
      if ($('.nessus-pro-page .try_nessus_pg .wrap-steps .form-items-wrap-1 .wrap-btn a').length > 0) {
        $(".nessus-pro-page .try_nessus_pg .wrap-steps .form-items-wrap-1 .wrap-btn a").html("<span>Continue</span><img alt='Arrow Left' src='/themes/custom/tenable/img/products/nessus/arrow-left.png'>").addClass('btn-2017--orange');
        $(".nessus-pro-page .try_nessus_pg .wrap-steps .form-items-wrap-2 .wrap-btn a").html("<img alt='Arrow Left' src='/themes/custom/tenable/img/products/nessus/arrow-left.png'><span>Go Back</span>");

        clearInterval(check_form_button);
      }
    }, 100);
      $('.nessus-pro-page .buy-now-custom label').click(function () {
        $(this).closest('form').find('.radio-selected').removeClass('radio-selected');
        $(this).addClass('radio-selected');
      });
    /* Nessus Product Page 2020 Redesign End */

    $(".seo-glossary__alpha-list .views-element-container .view-seo-glossary .view-content .views-row").each( function () {
      var letter = $(this).find('.views-field-name-1').find('.field-content').text().trim();
      $(".seo-glossary__filter-alpha a:contains('"+letter+"')").removeClass('disabled');
    });

    $('.seo-glossary__filter-search #edit-search').parent().append('<span class="glossary-search-submit" id="glossary-search-submit"></span>');
    $('#glossary-search-submit').click( function () {
      $(this).parent().parent().submit();
    });
    let params = new URLSearchParams(window.location.search);
    let byLetter = parseInt(params.get("by_letter")) - 1;
    $(".seo-glossary__filter-alpha a:eq("+byLetter.toString()+")").addClass('active');

    $('.seo-glossary__filter-alpha a').click( function (e) {
      e.preventDefault();
      var _this = $(this), _value = _this.text().toUpperCase(), select = $('#edit-by-letter'), form = $('#views-exposed-form-seo-glossary-index');

      $('.seo-glossary__filter-alpha a').each( function () {
        $(this).removeClass('active');
      });
      _this.addClass('active');
      $("#edit-by-letter option").each( function () {
        if ($(this).text() == _value) {
          $(this).attr('selected','selected');
        }
      });
      if (_value.length > 1) {
        $('#edit-by-letter option:eq(0)').attr('selected','selected');
      }
      $('.seo-glossary__filter-search #edit-search').val('');
      form.submit();
    });

    $('.seo-glossary__filter-search #edit-search').on('focus', function() {
      $('#edit-by-letter option:eq(0)').attr('selected','selected');
    });

    if ($('.seo-glossary__filter-search').length > 0) {
      const urlParams = new URLSearchParams(window.location.search);
      const filterLetter = urlParams.get('by_letter'), filterSearch = urlParams.get('search');

      if (filterLetter.length > 1) {
        filterLetter = 0;
      }

      if (urlParams != '' && urlParams != undefined && filterSearch == '') {
        $('html, body').animate({
              scrollTop: $('.seo-glossary__filter-alpha a:eq('+filterLetter+')').offset().top - ($('#site-nav').height() + 100)
        }, 2000);
      } else if (filterSearch != '' && urlParams != '' && urlParams != undefined) {
        $('html, body').animate({
              scrollTop: $('.seo-glossary__terms-container .container').offset().top - ($('#site-nav').height() + 100)
        }, 2000);
      }

    }

    if ($('.seo-glossary__terms-container').length > 0) {
      $(window).scroll(function (e) {
        var $el = $('.seo-glossary__terms-container');
        //var isPositionFixed = ($el.css('position') == 'fixed');
        var navBottom = $('#site-nav').offset().top + $('#site-nav').height();
        var filterTopAlign = parseInt($('#site-nav').height()) + parseInt($('#site-nav').css('margin-top')) + 24;
        var filterTop = $el.offset().top;
        if (navBottom > filterTop) {
          $('.seo-glossary__filter').css({'top': filterTopAlign + 'px'}).addClass('accordion-content');
        } else {
          $('.seo-glossary__filter').css({'top': '0px'}).removeClass('accordion-content');
        }
      });
    }

    $( document ).ready(function() {
      if (document.getElementById("views-exposed-form-resource-library-page-webinars")) {
        $("#views-exposed-form-resource-library-page-webinars select").each(function (index, elem) {
          if ($(this).val() === "All") {
            var elemId = $(elem).attr('id');
            var elemLabel = $('label[for="'+elemId+'"]').text();
            // console.log(elemLabel);
            $(this).append('<option value="" disabled selected hidden>'+elemLabel+'</option>');
          }
        });
  
      }
    });

  $( document ).ready(function() {
    // Homepage Lottie Animations
    if (document.getElementById("exposure-management-animation")) {
      var exposureAnimation = bodymovin.loadAnimation({
        container: document.getElementById('exposure-management-animation'),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '../themes/custom/tenable/img/home/t1/home-graph.json'
      });

      $('#exposure-management-animation').viewportChecker({
        classToAdd: 'js-animate',
        callbackFunction: function (elem, action) {
          exposureAnimation.play();
        },
      });

    }

    if (document.getElementById("hero-animation")) {
      var heroAnimation = bodymovin.loadAnimation({
        container: document.getElementById('hero-animation'),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '../themes/custom/tenable/img/home/t1/hero-animation.json'
      });

      $('#hero-animation').viewportChecker({
        classToAdd: 'js-animate',
        callbackFunction: function (elem, action) {
          heroAnimation.play();
        },
      });
    }

  });

  // if ($(window).width() < '768') {
  //   $('.featured-solutions__tab').each( function () {
  //     var _this = $(this);
  //     if (_this.hasClass('js-active')) {
  //       _this.addClass('active');
  //     }
  //   });
  //   $('.featured-solutions__tab').click( function () {
  //     var _this = $(this);
  //       _this.toggleClass('active');
  //       _this.removeClass('js-active');
  //       $('.featured-solutions__tab').not(this).removeClass('active');
  //   });
  // }

  // Homepage tabs

  function mobileTabs() {
    // console.log('mobile')
    $('.featured-solutions__tab-inner').off().click( function (e) {
      if ($(window).width() < 786) {
        e.stopPropagation();
        var _this = $(this).closest('.featured-solutions__tab');
        // console.log('mob click');
        // console.log(this);
        // console.log(_this);

        if ($(_this).hasClass('js-active')) {
          $(_this).removeClass('js-active');
        } else {
          $('.featured-solutions__tab').not(_this).removeClass('js-active');
          $(_this).addClass('js-active');
        }
      }

    });
  }

  function desktopTabs() {
    $('.featured-solutions__tab-inner').off('click').hover(function (e) {
      if ($(window).width() > 787) {
        e.stopPropagation();
        var _this = $(this).parents('.featured-solutions__tab');
        var num_id = $(_this).attr('class').match(/tab-(\d+)/)[1];
        $(_this).parents('.featured-solutions').find('.featured-solutions__tab, .featured-solutions__item').removeClass('js-active');
        $(_this).addClass('js-active');
        $(_this).closest('.featured-solutions').find('.content-' + num_id).addClass('js-active');
        $(_this).parents('.featured-solutions').attr('data-active', num_id);
      }
    })
  }

  // Initial check on page load
  if ($(window).width() > 787) {
    // console.log('desktop init');
    desktopTabs();
  } else {
    // console.log('mobile init');
    mobileTabs();
  }

  // Watch for screen size changes
  $(window).resize(function(){
    if ($(window).width() > 787) {
      // $('.featured-solutions__tab').removeClass('js-active');
      // console.log('desktop');
      desktopTabs();
    } else {
      // console.log('mobile');
      mobileTabs();
    }
  });



  $('.animate-in-view').viewportChecker({
    classToAdd: 'js-animated',
    // classToRemove: 'animate-in-view'
  });

  $( document ).ready(function() {
    if ($('.ctable--nessus-ad .ctable__header-wrap').length > 0) {
      $(".ctable--nessus-ad .ctable__header-wrap").stick_in_parent({
        offset_top: 69,
      });
    }
    if ($('.ctable--2023 .ctable__header-wrap').length > 0) {
      $(".ctable--2023 .ctable__header-wrap").stick_in_parent({
        offset_top: 100,
      });
    }
    if ($('.js-comptable-sticky-header .header-row').length > 0) {
      $(".js-comptable-sticky-header .header-row").stick_in_parent({
        offset_top: 50,
      });
    }
    if ($('.c-comptable__nessus.js-comptable-sticky-header .division-row').length > 0) {
      var offset = 170;
      if($(window).width() < 1024){ offset = 60; }
      else if($(window).width() >= 1024 && $(window).width() <= 1366){
        var heroHeight = $('.c-comptable__row.header-row').outerHeight();
        console.log(heroHeight)
        offset = 50 + heroHeight;
      }
      $(".js-comptable-sticky-header .division-row").stick_in_parent({
        offset_top: offset,
      });
    }
  });

  if ($('.eval-form-container .marketo-floating-label, .contact-mkto-form .marketo-floating-label, .try-buy-hanging-label').length > 0) {
      MktoForms2.whenReady(function(form) {
        var formElement = form.getFormElem();
        if ( formElement.closest('.js-form-hanging-label').length > 0 ) {
          // Custom handling for new hanging label setup
          return;
        }
        formElement.find('.mktoField').change(function() {
          $(this).parent().addClass(['focused','typing']);
        });

        formElement.find('textarea').change(function() {
          $(this).parent().addClass(['focused','typing']);
        });
      });
  }

  if($('.js-search-hanging-label').length > 0){
    if($('.js-search-hanging-label form input[id^=edit-combine]').val() != ''){
      $('.js-search-hanging-label form input[id^=edit-combine]').addClass(['focused','typing']);
    }
    $('.js-search-hanging-label form input[id^=edit-combine]').change(function() {
      $(this).addClass(['focused','typing']);
    });
  }

  // Vertical tabs, clone mobile content
  if ($('.c-vtabs--clone-mobile').length > 0) {


    $('.c-vtabs--clone-mobile .c-vtabs__content').each(function(index){
      var content = $(this).html();
      $('.c-vtabs__mobile-content').eq(index).html(content);
    })
  }

  $('.js-tab-wrap .js-tab').click(function(e){
    // e.preventDefault();
    var num_id = $(this).attr('class').match(/tab-(\d+)/)[1];
    $(this).parents('.js-tab-wrap').find('.js-tab, .js-tab-content').removeClass('js-active').removeAttr('href');
    $(this).addClass('js-active');
    $(this).closest('.js-tab-wrap').find('.content-'+num_id).addClass('js-active');
    $(this).parents('.js-tab-wrap').attr('data-active', num_id);
  });



})(jQuery);



if (window.location.pathname.match('-podcast')) {
  jQuery('audio').mediaelementplayer({pluginPath: '/themes/custom/tenable/js/', audioWidth: 300});
}

if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
